export const strings = [
    {
        "English": "Submit",
        "French": "Soumettre",
        "Spanish": "Entregar",
        "key": "Submit"
    },
    {
        "English": "Info",
        "French": "Informations",
        "Spanish": "Información",
        "key": "Info"
    },
    {
        "English": "Please enter valid email",
        "French": "Veuillez entrer une adresse e-mail valide",
        "Spanish": "Por favor ingrese un correo electrónico válido",
        "key": "Please_enter_valid_email"
    },
    {
        "English": "Close",
        "French": "Fermer",
        "Spanish": "Cerrar",
        "key": "Close"
    },
    {
        "English": "Error",
        "French": "Erreur",
        "Spanish": "Error",
        "key": "Error"
    },
    {
        "English": "Success",
        "French": "Succès",
        "Spanish": "Éxito",
        "key": "Success"
    },
    {
        "English": "Download",
        "French": "Télécharger",
        "Spanish": "Descargar",
        "key": "Download"
    },
    {
        "English": "Payment Method",
        "French": "Méthode de Paiement",
        "Spanish": "Método de Pago",
        "key": "Payment_Method"
    },
    {
        "English": "Transit",
        "French": "Transit",
        "Spanish": "Tránsito",
        "key": "Transit"
    },
    {
        "English": "Bank Details",
        "French": "Coordonnées bancaires",
        "Spanish": "Detalles bancarios",
        "key": "Bank_Details"
    },
    {
        "English": "Clear",
        "French": "Clair",
        "Spanish": "Claro",
        "key": "Clear"
    },
    {
        "English": "Preview",
        "French": "Aperçu",
        "Spanish": "Vista previa",
        "key": "Preview"
    },
    {
        "English": "First Name",
        "French": "Prénom",
        "Spanish": "Nombre",
        "key": "First_Name"
    },
    {
        "English": "Please enter first name",
        "French": "Veuillez saisir votre prénom",
        "Spanish": "Por favor ingrese el nombre",
        "key": "Please_enter_first_name"
    },
    {
        "English": "Last Name",
        "French": "Nom",
        "Spanish": "Apellido",
        "key": "Last_Name"
    },
    {
        "English": "Please enter last name",
        "French": "Veuillez entrer votre nom de famille",
        "Spanish": "Por favor ingrese el apellido",
        "key": "Please_enter_last_name"
    },
    {
        "English": "Please enter email",
        "French": "Veuillez saisir votre adresse e-mail",
        "Spanish": "Por favor ingrese el correo electrónico",
        "key": "Please_enter_email"
    },
    {
        "English": "Verify",
        "French": "Vérifier",
        "Spanish": "Verificar",
        "key": "Verify"
    },
    {
        "English": "Review and Sign the PAD Agreement",
        "French": "Examiner et signer l’accord PAD",
        "Spanish": "Revisar y firmar el Acuerdo PAD",
        "key": "Review_and_Sign_the_PAD_Agreement"
    },
    {
        "English": "PAD Agreement",
        "French": "Accord DPA",
        "Spanish": "Acuerdo PAD",
        "key": "PAD_Agreement"
    },
    {
        "English": "Sign & Agree",
        "French": "Signer et accepter",
        "Spanish": "Firmar y aceptar",
        "key": "Sign_Agree"
    },
    {
        "English": "Reject",
        "French": "Rejeter",
        "Spanish": "Rechazar",
        "key": "Reject"
    },
    {
        "English": "Signature",
        "French": "Signature",
        "Spanish": "Firma",
        "key": "Signature"
    },
    {
        "English": "Confirm",
        "French": "Confirmer",
        "Spanish": "Confirmar",
        "key": "Confirm"
    },
    {
        "English": "Agree",
        "French": "Accepter",
        "Spanish": "Aceptar",
        "key": "Agree"
    },
    {
        "English": "Please enter valid postal code",
        "French": "Veuillez entrer un code postal valide",
        "Spanish": "Por favor, introduzca el código postal válido",
        "key": "Please_enter_valid_postal_code"
    },
    {
        "English": "Please enter postal code",
        "French": "Veuillez entrer le code postal",
        "Spanish": "Por favor ingrese el código postal",
        "key": "Please_enter_postal_code"
    },
    {
        "English": "Cancel",
        "French": "Annuler",
        "Spanish": "Cancelar",
        "key": "Cancel"
    },
    {
        "English": "Update",
        "French": "Mettre à jour",
        "Spanish": "Actualizar",
        "key": "Update"
    },
    {
        "English": "Is your spouse covered by another Health and/or Dental insurance plan through their employer?",
        "French": "Votre conjoint est-il couvert par un autre régime d'assurance maladie et/ou dentaire par l'intermédiaire de son employeur ?",
        "Spanish": "¿Su cónyuge está cubierto por otro plan de seguro médico y/o dental a través de su empleador?",
        "key": "Is_your_spouse_covered_by_another_Health_and_or_Dental_insurance_plan_through_their_employer"
    },
    {
        "English": "Please enter name of carrier",
        "French": "Veuillez entrer le nom du transporteur",
        "Spanish": "Por favor ingrese el nombre del transportista",
        "key": "Please_enter_name_of_carrier"
    },
    {
        "English": "Coverage",
        "French": "Couverture",
        "Spanish": "Cobertura",
        "key": "Coverage"
    },
    {
        "English": "Is your dependent covered by another Health and/or Dental Insurance plan?",
        "French": "La personne à votre charge est-elle couverte par un autre régime d'assurance maladie et/ou dentaire ?",
        "Spanish": "¿Su dependiente está cubierto por otro plan de seguro médico y/o dental?",
        "key": "Is_your_dependent_covered_by_another_Health_and_or_Dental_Insurance_plan"
    },
    {
        "English": "Dependent with Special Needs",
        "French": "Personne à charge ayant des besoins spéciaux",
        "Spanish": "Dependiente con Necesidades Especiales",
        "key": "Dependent_with_Special_Needs"
    },
    {
        "English": "Beneficiary",
        "French": "Bénéficiaire",
        "Spanish": "Beneficiario",
        "key": "Beneficiary"
    },
    {
        "English": "Add",
        "French": "Ajouter",
        "Spanish": "Agregar",
        "key": "Add"
    },
    {
        "English": "Relation",
        "French": "Relation",
        "Spanish": "Relación",
        "key": "Relation"
    },
    {
        "English": "Percentage",
        "French": "Pourcentage*",
        "Spanish": "Porcentaje",
        "key": "Percentage"
    },
    {
        "English": "Action",
        "French": "Action",
        "Spanish": "Acción",
        "key": "Action"
    },
    {
        "English": "Place of Birth",
        "French": "Lieu de naissance",
        "Spanish": "Lugar de nacimiento",
        "key": "Place_of_Birth"
    },
    {
        "English": "Occupation",
        "French": "Profession",
        "Spanish": "Ocupación",
        "key": "Occupation"
    },
    {
        "English": "In the last 12 months, have you used, in any form whatsoever, tobacco, nicotine or cannabis mixed with tobacco?",
        "French": "Au cours des 12 derniers mois, avez-vous consommé, sous quelque forme que ce soit, du tabac, de la nicotine ou du cannabis mélangé à du tabac ?",
        "Spanish": "En los últimos 12 meses, ¿ha consumido, en cualquier forma, tabaco, nicotina o cannabis mezclado con tabaco?",
        "key": "In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco"
    },
    {
        "English": "Street Address",
        "French": "Adresse",
        "Spanish": "Dirección",
        "key": "Street_Address"
    },
    {
        "English": "City",
        "French": "Ville",
        "Spanish": "Ciudad",
        "key": "City"
    },
    {
        "English": "Province",
        "French": "Province",
        "Spanish": "Provincia",
        "key": "Province"
    },
    {
        "English": "Postal Code",
        "French": "Code postal",
        "Spanish": "Código postal",
        "key": "Postal_Code"
    },
    {
        "English": "Previous",
        "French": "Précédent",
        "Spanish": "Anterior",
        "key": "Previous"
    },
    {
        "English": "Version",
        "French": "Version",
        "Spanish": "Versión",
        "key": "Version"
    },
    {
        "English": "Select",
        "French": "Sélectionner",
        "Spanish": "Seleccionar",
        "key": "Select"
    },
    {
        "English": "Plan Enrollment Date",
        "French": "Date d'adhésion au plan",
        "Spanish": "Fecha de inscripción del plan",
        "key": "Plan_Enrollment_Date"
    },
    {
        "English": "Proceed",
        "French": "Continuer",
        "Spanish": "Proceder",
        "key": "Proceed"
    },
    {
        "English": "S.no",
        "French": "S.non",
        "Spanish": "S.no",
        "key": "S_no"
    },
    {
        "English": "Monthly Premium",
        "French": "Prime mensuelle",
        "Spanish": "Prima Mensual",
        "key": "Monthly_Premium"
    },
    {
        "English": "No",
        "French": "Non",
        "Spanish": "No",
        "key": "No"
    },
    {
        "English": "Amount",
        "French": "Montant",
        "Spanish": "Cantidad",
        "key": "Amount"
    },
    {
        "English": "Yes",
        "French": "Oui",
        "Spanish": "Sí",
        "key": "Yes"
    },
    {
        "English": "Email",
        "French": "Email",
        "Spanish": "Correo electrónico",
        "key": "Email"
    },
    {
        "English": "Unit/Apt/Suite",
        "French": "Unité/Appartement/Suite",
        "Spanish": "Unidad/Apto/Suite",
        "key": "Unit_Apt_Suite"
    },
    {
        "English": "Please select Province",
        "French": "Veuillez sélectionner une province",
        "Spanish": "Por favor seleccione Provincia",
        "key": "Please_select_Province"
    },
    {
        "English": "Phone Number",
        "French": "Numéro de Téléphone",
        "Spanish": "Número de Teléfono",
        "key": "Phone_Number"
    },
    {
        "English": "Phone number minimum of 10 digits",
        "French": "Numéro de téléphone à 10 chiffres minimum",
        "Spanish": "Número de teléfono mínimo de 10 dígitos",
        "key": "Phone_number_minimum_of_10_digits"
    },
    {
        "English": "Add More",
        "French": "Ajouter plus",
        "Spanish": "Añadir más",
        "key": "Add_More"
    },
    {
        "English": "Credit Card",
        "French": "Carte de crédit",
        "Spanish": "Tarjeta de crédito",
        "key": "Credit_Card"
    },
    {
        "English": "Type",
        "French": "Taper",
        "Spanish": "Tipo",
        "key": "Type"
    },
    {
        "English": "Date of Hire",
        "French": "Date d’embauche",
        "Spanish": "Fecha de contratación",
        "key": "Date_of_Hire"
    },
    {
        "English": "Date of Birth",
        "French": "Date de naissance",
        "Spanish": "Fecha de nacimiento",
        "key": "Date_of_Birth"
    },
    {
        "English": "Gender",
        "French": "Genre",
        "Spanish": "Género",
        "key": "Gender"
    },
    {
        "English": "Province of Employment",
        "French": "Province d'emploi",
        "Spanish": "Provincia de Empleo",
        "key": "Province_of_Employment"
    },
    {
        "English": "Other",
        "French": "Autre",
        "Spanish": "Otro",
        "key": "Other"
    },
    {
        "English": "Save",
        "French": "Enregistrer",
        "Spanish": "Guardar",
        "key": "Save"
    },
    {
        "English": "Phone number maximum of 10 digits",
        "French": "Numéro de téléphone de 10 chiffres maximum",
        "Spanish": "Número de teléfono máximo de 10 dígitos",
        "key": "Phone_number_maximum_of_10_digits"
    },
    {
        "English": "Single",
        "French": "Célibataire",
        "Spanish": "Soltero",
        "key": "Single"
    },
    {
        "English": "Couple",
        "French": "Couple",
        "Spanish": "Pareja",
        "key": "Couple"
    },
    {
        "English": "Family",
        "French": "Famille",
        "Spanish": "Familia",
        "key": "Family"
    },
    {
        "English": "Job Title",
        "French": "Titre d'emploi",
        "Spanish": "Título profesional",
        "key": "Job_Title"
    },
    {
        "English": "Male",
        "French": "Mâle",
        "Spanish": "Masculino",
        "key": "Male"
    },
    {
        "English": "Female",
        "French": "Femelle",
        "Spanish": "Femenino",
        "key": "Female"
    },
    {
        "English": "Undisclosed",
        "French": "Non divulgué",
        "Spanish": "No revelado",
        "key": "Undisclosed"
    },
    {
        "English": "Please select gender",
        "French": "Veuillez sélectionner le sexe",
        "Spanish": "Por favor seleccione género",
        "key": "Please_select_gender"
    },
    {
        "English": "Invalid file type. Only jpg, png image,pdf files are allowed.",
        "French": "Type de fichier invalide. Seuls les fichiers jpg, image png et pdf sont autorisés.",
        "Spanish": "Tipo de archivo no válido. Sólo se permiten archivos jpg, imagen png y pdf.",
        "key": "Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed"
    },
    {
        "English": "File size is too large,maximum file size is 300kb",
        "French": "La taille du fichier est trop grande, la taille maximale du fichier est de 300 Ko",
        "Spanish": "El tamaño del archivo es demasiado grande, el tamaño máximo del archivo es 300 kb",
        "key": "File_size_is_too_large_maximum_file_size_is_300kb"
    },
    {
        "English": "Alert",
        "French": "Alerte",
        "Spanish": "Alerta",
        "key": "Alert"
    },
    {
        "English": "Street Address Line 2",
        "French": "Adresse ligne 2",
        "Spanish": "Dirección línea 2",
        "key": "Street_Address_Line_2"
    },
    {
        "English": "Please choose graduation date",
        "French": "Veuillez choisir la date d'obtention du diplôme",
        "Spanish": "Por favor elija la fecha de graduación",
        "key": "Please_choose_graduation_date"
    },
    {
        "English": "Graduation Day",
        "French": "Jour de remise des diplômes",
        "Spanish": "día de graduación",
        "key": "Graduation_Day"
    },
    {
        "English": "Card Number",
        "French": "Numéro de carte",
        "Spanish": "Número de tarjeta",
        "key": "Card_Number"
    },
    {
        "English": "Last Name minimum of 2 Characters and without numbers",
        "French": "Nom de famille minimum de 2 caractères et sans chiffres",
        "Spanish": "Apellido mínimo de 2 Caracteres y sin números",
        "key": "Last_Name_minimum_of_2_Characters_and_without_numbers"
    },
    {
        "English": "First Name minimum of 2 Characters and without numbers",
        "French": "Prénom minimum de 2 caractères et sans chiffres",
        "Spanish": "Nombre mínimo de 2 Caracteres y sin números",
        "key": "First_Name_minimum_of_2_Characters_and_without_numbers"
    },
    {
        "English": "Please choose spouse insurance status",
        "French": "Veuillez choisir le statut d'assurance du conjoint",
        "Spanish": "Elija el estado del seguro del cónyuge",
        "key": "Please_choose_spouse_insurance_status"
    },
    {
        "English": "Spouse",
        "French": "Conjoint",
        "Spanish": "Cónyuge",
        "key": "Spouse"
    },
    {
        "English": "Please enter Date of Birth",
        "French": "Veuillez entrer la date de naissance",
        "Spanish": "Por favor ingrese la fecha de nacimiento",
        "key": "Please_enter_Date_of_Birth"
    },
    {
        "English": "Next",
        "French": "Suivant",
        "Spanish": "Próximo",
        "key": "Next"
    },
    {
        "English": "Please enter Phone Number",
        "French": "Veuillez entrer le numéro de téléphone",
        "Spanish": "Por favor ingrese el número de teléfono",
        "key": "Please_enter_Phone_Number"
    },
    {
        "English": "Are you sure you want to delete this License?",
        "French": "Êtes-vous sûr de vouloir supprimer cette licence ?",
        "Spanish": "¿Está seguro de que desea eliminar esta licencia?",
        "key": "Are_you_sure_you_want_to_delete_this_License"
    },
    {
        "English": "Choose File",
        "French": "Choisir un fichier",
        "Spanish": "Elegir archivo",
        "key": "Choose_File"
    },
    {
        "English": "Bank Number",
        "French": "Numéro de Banque",
        "Spanish": "Número de Banco",
        "key": "Bank_Number"
    },
    {
        "English": "Update Beneficiary Information",
        "French": "Mettre à jour les informations sur le bénéficiaire",
        "Spanish": "Actualizar información del beneficiario",
        "key": "Update_Beneficiary_Information"
    },
    {
        "English": "Account Number",
        "French": "Numéro de Compte",
        "Spanish": "Número de Cuenta",
        "key": "Account_Number"
    },
    {
        "English": "Transit Number",
        "French": "Numéro de transit",
        "Spanish": "Número de tránsito",
        "key": "Transit_Number"
    },
    {
        "English": "Upload Void Cheque",
        "French": "Télécharger un chèque annulé",
        "Spanish": "Cargar cheque anulado",
        "key": "Upload_Void_Cheque"
    },
    {
        "English": "Beneficiary Information",
        "French": "Informations sur le bénéficiaire",
        "Spanish": "Información del beneficiario",
        "key": "Beneficiary_Information"
    },
    {
        "English": "Please enter valid Card number",
        "French": "Veuillez saisir un numéro de carte valide",
        "Spanish": "Por favor ingrese un número de tarjeta válido",
        "key": "Please_enter_valid_Card_number"
    },
    {
        "English": "View",
        "French": "Voir",
        "Spanish": "Vista",
        "key": "View"
    },
    {
        "English": "Total",
        "French": "Total",
        "Spanish": "Total",
        "key": "Total"
    },
    {
        "English": "Guaranteed Approval",
        "French": "Approbation garantie",
        "Spanish": "Aprobación garantizada",
        "key": "Guaranteed_Approval"
    },
    {
        "English": "Pending Approval",
        "French": "En attente d'approbation",
        "Spanish": "Pendiente de aprobación",
        "key": "Pending_Approval"
    },
    {
        "English": "The GroupBenefitz Platform Inc.",
        "French": "La Plateforme GroupBenefitz Inc.",
        "Spanish": "El grupo Benefitz Platform Inc.",
        "key": "The_GroupBenefitz_Platform_Inc"
    },
    {
        "English": "Version",
        "French": "Version",
        "Spanish": "Versión",
        "key": "Version"
    },
    {
        "English": "Post-Secondary Student",
        "French": "Étudiant postsecondaire",
        "Spanish": "Estudiante postsecundario",
        "key": "Post_Secondary_Student"
    },
    {
        "English": "Tax",
        "French": "Impôt",
        "Spanish": "Impuesto",
        "key": "Tax"
    },
    {
        "English": "IGBMS Id",
        "French": "Identifiant IGBMS",
        "Spanish": "Identificación del IGBMS",
        "key": "IGBMS_Id"
    },
    {
        "English": "ROE Agreement",
        "French": "Accord RE",
        "Spanish": "Acuerdo ROE",
        "key": "ROE_Agreement"
    },
    {
        "English": "Bank Code",
        "French": "Code Bancaire",
        "Spanish": "Código Bancario",
        "key": "Bank_Code"
    },
    {
        "English": "Bank code must be 3 digits",
        "French": "Le code bancaire doit être composé de 3 chiffres",
        "Spanish": "El código bancario debe tener 3 dígitos.",
        "key": "Bank_code_must_be_3_digits"
    },
    {
        "English": "Please enter bank code",
        "French": "Veuillez saisir le code bancaire",
        "Spanish": "Por favor ingrese el código bancario",
        "key": "Please_enter_bank_code"
    },
    {
        "English": "Bank transit must be 5 digits",
        "French": "Le transit bancaire doit être composé de 5 chiffres",
        "Spanish": "El tránsito bancario debe tener 5 dígitos.",
        "key": "Bank_transit_must_be_5_digits"
    },
    {
        "English": "Please enter bank transit",
        "French": "Veuillez saisir le transit bancaire",
        "Spanish": "Por favor ingrese tránsito bancario",
        "key": "Please_enter_bank_transit"
    },
    {
        "English": "Please enter Account number",
        "French": "Veuillez entrer le numéro de compte",
        "Spanish": "Por favor ingrese el número de cuenta",
        "key": "Please_enter_Account_number"
    },
    {
        "English": "Account No",
        "French": "Numéro de compte ",
        "Spanish": "Número de cuenta ",
        "key": "Account_No"
    },
    {
        "English": "Account number minimum of 5 digits",
        "French": "Numéro de compte minimum de 5 chiffres",
        "Spanish": "Número de cuenta mínimo de 5 dígitos",
        "key": "Account_number_minimum_of_5_digits"
    },
    {
        "English": "Please enter Card number",
        "French": "Veuillez saisir le numéro de carte",
        "Spanish": "Por favor ingrese el número de tarjeta",
        "key": "Please_enter_Card_number"
    },
    {
        "English": "Expiry Month",
        "French": "Mois d'expiration",
        "Spanish": "Mes de vencimiento",
        "key": "Expiry_Month"
    },
    {
        "English": "Please select expiry month",
        "French": "Veuillez sélectionner le mois d'expiration",
        "Spanish": "Por favor seleccione el mes de vencimiento",
        "key": "Please_select_expiry_month"
    },
    {
        "English": "CVV",
        "French": "CVV",
        "Spanish": "CVV",
        "key": "CVV"
    },
    {
        "English": "Expiry Year",
        "French": "Année d'expiration",
        "Spanish": "Año de vencimiento",
        "key": "Expiry_Year"
    },
    {
        "English": "Please select expiry year",
        "French": "Veuillez sélectionner l'année d'expiration",
        "Spanish": "Por favor seleccione el año de vencimiento",
        "key": "Please_select_expiry_year"
    },
    {
        "English": "CVV must be 3 or 4 digits",
        "French": "Le CVV doit être composé de 3 ou 4 chiffres",
        "Spanish": "CVV debe tener 3 o 4 dígitos",
        "key": "CVV_must_be_3_or_4_digits"
    },
    {
        "English": "Please enter cvv",
        "French": "Veuillez entrer cvv",
        "Spanish": "Por favor introduce cvv",
        "key": "Please_enter_cvv"
    },
    {
        "English": "Are you sure you want to delete?",
        "French": "Êtes-vous sûr de vouloir supprimer ?",
        "Spanish": "¿Estás seguro de que deseas eliminar?",
        "key": "Are_you_sure_you_want_to_delete"
    },
    {
        "English": "Broker",
        "French": "Courtier",
        "Spanish": "Corredor",
        "key": "Broker"
    },
    {
        "English": "Form",
        "French": "Formulaire",
        "Spanish": "Forma",
        "key": "Form"
    },
    {
        "English": "Please select Form type",
        "French": "Veuillez sélectionner le type de formulaire",
        "Spanish": "Por favor seleccione tipo de formulario",
        "key": "Please_select_Form_type"
    },
    {
        "English": "Plan Selection",
        "French": "Sélection de forfaits",
        "Spanish": "Selección de planes",
        "key": "Plan_Selection"
    },
    {
        "English": "Personal Info",
        "French": "Informations personnelles",
        "Spanish": "Información personal",
        "key": "Personal_Info"
    },
    {
        "English": "Please select broker name",
        "French": "Veuillez sélectionner le nom du courtier",
        "Spanish": "Por favor seleccione el nombre del corredor",
        "key": "Please_select_broker_name"
    },
    {
        "English": "Employee Information",
        "French": "Informations sur les employés",
        "Spanish": "Información del empleado",
        "key": "Employee_Information"
    },
    {
        "English": "Enrollment Summary",
        "French": "Résumé des inscriptions",
        "Spanish": "Resumen de inscripción",
        "key": "Enrollment_Summary"
    },
    {
        "English": "Please choose plan enrollment date",
        "French": "Veuillez choisir la date d'adhésion au plan",
        "Spanish": "Por favor elija la fecha de inscripción al plan",
        "key": "Please_choose_plan_enrollment_date"
    },
    {
        "English": "Invalid phone number format",
        "French": "Format de numéro de téléphone invalide",
        "Spanish": "Formato de número de teléfono no válido",
        "key": "Invalid_phone_number_format"
    },
    {
        "English": "Please Choose Date of Birth",
        "French": "Veuillez choisir votre date de naissance",
        "Spanish": "Por favor elija fecha de nacimiento",
        "key": "Please_Choose_Date_of_Birth"
    },
    {
        "English": "Registrant age must be 16 or greater",
        "French": "L'âge de l'inscrit doit être de 16 ans ou plus",
        "Spanish": "La edad del registrante debe ser mayor de 16 años.",
        "key": "Registrant_age_must_be_16_or_greater"
    },
    {
        "English": "Registrant age must be 60 or below",
        "French": "L'âge du participant doit être de 60 ans ou moins",
        "Spanish": "La edad del registrante debe ser 60 años o menos.",
        "key": "Registrant_age_must_be_60_or_below"
    },
    {
        "English": "Non_Binary",
        "French": "Non_binaire",
        "Spanish": "No binario",
        "key": "Non_Binary"
    },
    {
        "English": "undisclosed",
        "French": "non divulgué",
        "Spanish": "no revelado",
        "key": "undisclosed"
    },
    {
        "English": "Please Select Gender",
        "French": "Veuillez sélectionner le sexe",
        "Spanish": "Por favor seleccione género",
        "key": "Please_Select_Gender"
    },
    {
        "English": "Please enter Street Address",
        "French": "Veuillez entrer l'adresse postale",
        "Spanish": "Por favor ingrese la dirección",
        "key": "Please_enter_Street_Address"
    },
    {
        "English": "Home Mailing Address",
        "French": "Adresse postale du domicile",
        "Spanish": "Dirección postal de casa",
        "key": "Home_Mailing_Address"
    },
    {
        "English": "Please enter City",
        "French": "Veuillez entrer la ville",
        "Spanish": "Por favor ingrese la ciudad",
        "key": "Please_enter_City"
    },
    {
        "English": "Spouse Information",
        "French": "Informations sur le conjoint",
        "Spanish": "Información del cónyuge",
        "key": "Spouse_Information"
    },
    {
        "English": "I confirm that I am actively working 20 or more hours per week to meet plan eligibility",
        "French": "Je confirme que je travaille activement 20 heures ou plus par semaine pour répondre à mon admissibilité au plan.",
        "Spanish": "Confirmo que estoy trabajando activamente 20 horas o más por semana para cumplir con la elegibilidad del plan.",
        "key": "I_confirm_that_I_am_actively_working_20_or_more_hours_per_week_to_meet_plan_eligibility"
    },
    {
        "English": "To enroll in the plan you need to be working 20 or more hours per week",
        "French": "Pour adhérer au plan, vous devez travailler 20 heures ou plus par semaine",
        "Spanish": "Para inscribirse en el plan es necesario trabajar 20 horas o más por semana.",
        "key": "To_enroll_in_the_plan_you_need_to_be_working_20_or_more_hours_per_week"
    },
    {
        "English": "How many hours per week do you work?",
        "French": "Combien d'heures par semaine travaillez-vous ?",
        "Spanish": "¿Cuántas horas por semana trabajas?",
        "key": "How_many_hours_per_week_do_you_work"
    },
    {
        "English": "Hours Per week should be less than 80",
        "French": "Les heures par semaine devraient être inférieures à 80",
        "Spanish": "Las horas por semana deben ser menos de 80.",
        "key": "Hours_Per_week_should_be_less_than_80"
    },
    {
        "English": "Please select working hours per week",
        "French": "Veuillez sélectionner les heures de travail par semaine",
        "Spanish": "Por favor seleccione horas de trabajo por semana",
        "key": "Please_select_working_hours_per_week"
    },
    {
        "English": "Hours Per week should be more than 20",
        "French": "Les heures par semaine devraient être supérieures à 20",
        "Spanish": "Las horas por semana deben ser más de 20.",
        "key": "Hours_Per_week_should_be_more_than_20"
    },
    {
        "English": "You are not eligible to apply without a health card from your province.",
        "French": "Vous ne pouvez pas présenter de demande sans une carte Santé de votre province.",
        "Spanish": "No eres elegible para postularte sin una tarjeta sanitaria de tu provincia.",
        "key": "You_are_not_eligible_to_apply_without_a_health_card_from_your_province"
    },
    {
        "English": "I confirm that I have provincial health coverage in my province of residence",
        "French": "Je confirme que j'ai une couverture santé provinciale dans ma province de résidence",
        "Spanish": "Confirmo que tengo cobertura sanitaria provincial en mi provincia de residencia",
        "key": "I_confirm_that_I_have_provincial_health_coverage_in_my_province_of_residence"
    },
    {
        "English": "Date of Arrival in Canada",
        "French": "Date d'arrivée au Canada",
        "Spanish": "Fecha de llegada a Canadá",
        "key": "Date_of_Arrival_in_Canada"
    },
    {
        "English": "Please select date of arrival in Canada",
        "French": "Veuillez sélectionner la date d'arrivée au Canada",
        "Spanish": "Por favor seleccione la fecha de llegada a Canadá",
        "key": "Please_select_date_of_arrival_in_Canada"
    },
    {
        "English": "Country of Origin",
        "French": "Pays d'origine",
        "Spanish": "País natal",
        "key": "Country_of_Origin"
    },
    {
        "English": "Please select country of origin.",
        "French": "Veuillez sélectionner le pays d'origine.",
        "Spanish": "Por favor seleccione país de origen.",
        "key": "Please_select_country_of_origin"
    },
    {
        "English": "Is the employee a landed immigrant?",
        "French": "L'employé est-il un immigrant reçu?",
        "Spanish": "¿Es el empleado un inmigrante desembarcado?",
        "key": "Is_the_employee_a_landed_immigrant"
    },
    {
        "English": "Please choose employee landed immigrant",
        "French": "Veuillez choisir un employé immigrant reçu",
        "Spanish": "Por favor elija empleado inmigrante desembarcado",
        "key": "Please_choose_employee_landed_immigrant"
    },
    {
        "English": "Will he/she be applying for landed status?",
        "French": "Va-t-il demander le statut d'établissement?",
        "Spanish": "¿Solicitará el estatus de terrateniente?",
        "key": "Will_he_she_be_applying_for_landed_status"
    },
    {
        "English": "Please choose landed status",
        "French": "Veuillez choisir le statut d'établissement",
        "Spanish": "Por favor elija el estado aterrizado",
        "key": "Please_choose_landed_status"
    },
    {
        "English": "Is coverage required for the employee?",
        "French": "Une couverture est-elle obligatoire pour le salarié ?",
        "Spanish": "¿Se requiere cobertura para el empleado?",
        "key": "Is_coverage_required_for_the_employee"
    },
    {
        "English": "Please select coverage required for employee.",
        "French": "Veuillez sélectionner la couverture requise pour l'employé.",
        "Spanish": "Seleccione la cobertura requerida para el empleado.",
        "key": "Please_select_coverage_required_for_employee"
    },
    {
        "English": "Do you have a spouse (married or living common-law for at least one year)?",
        "French": "Avez-vous un conjoint (marié ou vivant en union libre depuis au moins un an) ?",
        "Spanish": "¿Tiene cónyuge (casado o en unión libre durante al menos un año)?",
        "key": "Do_you_have_a_spouse_married_or_living_common_law_for_at_least_one_year"
    },
    {
        "English": "Please choose spouse status",
        "French": "Veuillez choisir le statut de conjoint",
        "Spanish": "Por favor elija el estado del cónyuge",
        "key": "Please_choose_spouse_status"
    },
    {
        "English": "Please enter spouse first name",
        "French": "Veuillez saisir le prénom du conjoint",
        "Spanish": "Por favor ingrese el nombre del cónyuge",
        "key": "Please_enter_spouse_first_name"
    },
    {
        "English": "Please enter spouse last name",
        "French": "Veuillez saisir le nom de famille du conjoint",
        "Spanish": "Por favor ingrese el apellido del cónyuge",
        "key": "Please_enter_spouse_last_name"
    },
    {
        "English": "Name Of The Carrier",
        "French": "Nom du transporteur",
        "Spanish": "Nombre del transportista",
        "key": "Name_Of_The_Carrier"
    },
    {
        "English": "Coordination of Benefits (COB) Coverage",
        "French": "Couverture de la Coordination des Prestations (COB)",
        "Spanish": "Cobertura de Coordinación de Beneficios (COB)",
        "key": "Coordination_of_Benefits_COB_Coverage"
    },
    {
        "English": "Please select name of COB Coverage",
        "French": "Veuillez sélectionner le nom de la couverture COB",
        "Spanish": "Por favor seleccione el nombre de la Cobertura COB",
        "key": "Please_select_name_of_COB_Coverage"
    },
    {
        "English": "Please enter name of the carrier",
        "French": "Veuillez entrer le nom du transporteur",
        "Spanish": "Por favor ingrese el nombre del transportista",
        "key": "Please_enter_name_of_the_carrier"
    },
    {
        "English": "Dependent Children Information",
        "French": "Informations sur les enfants à charge",
        "Spanish": "Información sobre hijos dependientes",
        "key": "Dependent_Children_Information"
    },
    {
        "English": "Please choose children status",
        "French": "Veuillez choisir le statut des enfants",
        "Spanish": "Por favor elija el estado de los niños",
        "key": "Please_choose_children_status"
    },
    {
        "English": "please select option",
        "French": "veuillez sélectionner l'option",
        "Spanish": "por favor seleccione la opción",
        "key": "please_select_option"
    },
    {
        "English": "Is Coverage required for Dependent(s)",
        "French": "La couverture est-elle requise pour les personnes à charge",
        "Spanish": "¿Se requiere cobertura para los dependientes?",
        "key": "Is_Coverage_required_for_Dependent_s"
    },
    {
        "English": "Dependent(s) Information",
        "French": "Informations sur les personnes à charge",
        "Spanish": "Información de dependientes",
        "key": "Dependent_s_Information"
    },
    {
        "English": "Please select coverage required for dependents(s).",
        "French": "Veuillez sélectionner la couverture requise pour les personnes à charge.",
        "Spanish": "Seleccione la cobertura requerida para los dependientes.",
        "key": "Please_select_coverage_required_for_dependents_s"
    },
    {
        "English": "Dependent(s) Date of Arrival in Canada",
        "French": "Personne(s) à charge Date d'arrivée au Canada",
        "Spanish": "Dependiente(s) Fecha de llegada a Canadá",
        "key": "Dependent_s_Date_of_Arrival_in_Canada"
    },
    {
        "English": "Please Select date of arrival in Canada",
        "French": "Veuillez sélectionner la date d'arrivée au Canada",
        "Spanish": "Por favor seleccione fecha de llegada a Canadá",
        "key": "Please_Select_date_of_arrival_in_Canada"
    },
    {
        "English": "Will they be applying for landed immigrant status?",
        "French": "Vont-ils demander le statut d’immigrant reçu ?",
        "Spanish": "¿Solicitarán el estatus de inmigrantes terratenientes?",
        "key": "Will_they_be_applying_for_landed_immigrant_status"
    },
    {
        "English": "Please Select dependent(s) landed immigrant",
        "French": "Veuillez sélectionner la ou les personnes à charge immigrant reçu",
        "Spanish": "Por favor seleccione dependiente(s) inmigrante aterrizado",
        "key": "Please_Select_dependent_s_landed_immigrant"
    },
    {
        "English": "Please select dependent(s) country of origin",
        "French": "Veuillez sélectionner le pays d'origine des personnes à charge",
        "Spanish": "Por favor seleccione el país de origen de los dependientes",
        "key": "Please_select_dependent_s_country_of_origin"
    },
    {
        "English": "Are the dependents landed immigrants?",
        "French": "Les personnes à charge sont-elles des immigrants reçus ?",
        "Spanish": "¿Los dependientes son inmigrantes desembarcados?",
        "key": "Are_the_dependents_landed_immigrants"
    },
    {
        "English": "Please Select dependents(s) landed status",
        "French": "Veuillez sélectionner les personnes à charge ayant le statut d'établissement",
        "Spanish": "Seleccione el estado de aterrizaje de los dependientes",
        "key": "Please_Select_dependents_s_landed_status"
    },
    {
        "English": "Company Paid",
        "French": "Payé par l'entreprise",
        "Spanish": "Pagado por la empresa",
        "key": "Company_Paid"
    },
    {
        "English": "Please Select status of dependent(s) in Canada",
        "French": "Veuillez sélectionner le statut des personnes à charge au Canada",
        "Spanish": "Seleccione el estado de los dependientes en Canadá",
        "key": "Please_Select_status_of_dependent_s_in_Canada"
    },
    {
        "English": "Will the dependent(s) be in Canada for more than 3 months?",
        "French": "La ou les personnes à charge seront-elles au Canada pendant plus de 3 mois ?",
        "Spanish": "¿Estarán los dependientes en Canadá por más de 3 meses?",
        "key": "Will_the_dependent_s_be_in_Canada_for_more_than_3_months"
    },
    {
        "English": "Upgrade To",
        "French": "Mettre à niveau vers",
        "Spanish": "Actualizar a",
        "key": "Upgrade_To"
    },
    {
        "English": "Voluntary",
        "French": "Volontaire",
        "Spanish": "Voluntario",
        "key": "Voluntary"
    },
    {
        "English": "Opy-In",
        "French": "Inscription",
        "Spanish": "Opy-In",
        "key": "Opy_In"
    },
    {
        "English": "Employee pays",
        "French": "L'employé paie",
        "Spanish": "El empleado paga",
        "key": "Employee_pays"
    },
    {
        "English": "Employee pays through payroll deduction",
        "French": "L'employé paie par retenues sur salaire",
        "Spanish": "El empleado paga mediante deducción de nómina",
        "key": "Employee_pays_through_payroll_deduction"
    },
    {
        "English": "Employee pays through CC/PAD",
        "French": "L'employé paie via CC/PAD",
        "Spanish": "El empleado paga a través de CC/PAD",
        "key": "Employee_pays_through_CC_PAD"
    },
    {
        "English": "Plans Enrolled",
        "French": "Plans inscrits",
        "Spanish": "Planes inscritos",
        "key": "Plans_Enrolled"
    },
    {
        "English": "Plan Name",
        "French": "Nom du régime",
        "Spanish": "Nombre del plan",
        "key": "Plan_Name"
    },
    {
        "English": "Home Address same as billing Address",
        "French": "Adresse du domicile identique à l'adresse de facturation",
        "Spanish": "Dirección de casa igual que la dirección de facturación",
        "key": "Home_Address_same_as_billing_Address"
    },
    {
        "English": "Pre_authorized_Debit",
        "French": "Débit_pré_autorisé",
        "Spanish": "Débito_preautorizado",
        "key": "Pre_authorized_Debit"
    },
    {
        "English": "AptSuite",
        "French": "AptSuite",
        "Spanish": "AptoSuite",
        "key": "AptSuite"
    },
    {
        "English": "Please enter valid aptSuite",
        "French": "Veuillez saisir une aptSuite valide",
        "Spanish": "Por favor introduce aptSuite válido",
        "key": "Please_enter_valid_aptSuite"
    },
    {
        "English": "SELECTED PLANS",
        "French": "FORFAITS SÉLECTIONNÉS",
        "Spanish": "PLANES SELECCIONADOS",
        "key": "SELECTED_PLANS"
    },
    {
        "English": "Plan",
        "French": "Plan",
        "Spanish": "Usuarios",
        "key": "Plan"
    },
    {
        "English": "(Employee)",
        "French": "(Employé)",
        "Spanish": "(Empleado)",
        "key": "Employee"
    },
    {
        "English": "All Selected Plans",
        "French": "Tous les forfaits sélectionnés",
        "Spanish": "Todos los planes seleccionados",
        "key": "All_Selected_Plans"
    },
    {
        "English": "Premium",
        "French": "Prime",
        "Spanish": "De primera calidad",
        "key": "Premium"
    },
    {
        "English": "Monthly Payment Summary",
        "French": "Sommaire des paiements mensuels",
        "Spanish": "Resumen de pago mensual",
        "key": "Monthly_Payment_Summary"
    },
    {
        "English": "Company Pays",
        "French": "L'entreprise paie",
        "Spanish": "La empresa paga",
        "key": "Company_Pays"
    },
    {
        "English": "Total charge to Company",
        "French": "Charge totale pour l'entreprise",
        "Spanish": "Cargo total a la empresa",
        "key": "Total_charge_to_Company"
    },
    {
        "English": "Total charge to Employee",
        "French": "Charge totale pour l'employé",
        "Spanish": "Cargo total al empleado",
        "key": "Total_charge_to_Employee"
    },
    {
        "English": "Plan Summary",
        "French": "Sommaire du régime",
        "Spanish": "Resumen del plan",
        "key": "Plan_Summary"
    },
    {
        "English": "Provincial Health Coverage",
        "French": "Couverture santé provinciale",
        "Spanish": "Cobertura de Salud Provincial",
        "key": "Provincial_Health_Coverage"
    },
    {
        "English": "Provincial health Coverage is a prerequisite. Please visit",
        "French": "La couverture santé provinciale est une condition préalable. Veuillez visiter",
        "Spanish": "La cobertura sanitaria provincial es un requisito previo. Por favor visita",
        "key": "Provincial_health_Coverage_is_a_prerequisite_Please_visit"
    },
    {
        "English": "to apply for provincial health coverage and reapply when it is received.",
        "French": "demander une assurance-maladie provinciale et présenter une nouvelle demande dès qu’elle est reçue.",
        "Spanish": "solicitar cobertura sanitaria provincial y volver a solicitarla cuando la reciba.",
        "key": "to_apply_for_provincial_health_coverage_and_reapply_when_it_is_received"
    },
    {
        "English": "Add Dependent",
        "French": "Ajouter une personne à charge",
        "Spanish": "Agregar dependiente",
        "key": "Add_Dependent"
    },
    {
        "English": "Update Dependent",
        "French": "Dépendant de la mise à jour",
        "Spanish": "Dependiente de la actualización",
        "key": "Update_Dependent"
    },
    {
        "English": "Please ensure the graduation date is later than the date of birth.",
        "French": "Veuillez vous assurer que la date d'obtention du diplôme est postérieure à la date de naissance.",
        "Spanish": "Asegúrese de que la fecha de graduación sea posterior a la fecha de nacimiento.",
        "key": "Please_ensure_the_graduation_date_is_later_than_the_date_of_birth"
    },
    {
        "English": "Choose Options",
        "French": "Choisissez les options",
        "Spanish": "Elija opciones",
        "key": "Choose_Options"
    },
    {
        "English": "The selection includes GreenShield plans. Do you want to provision in GreenShield?",
        "French": "La sélection comprend des plans GreenShield. Souhaitez-vous effectuer un provisionnement dans GreenShield ?",
        "Spanish": "La selección incluye planes GreenShield. ¿Quieres aprovisionar en GreenShield?",
        "key": "The_selection_includes_GreenShield_plans_Do_you_want_to_provision_in_GreenShield"
    },
    {
        "English": "Provision",
        "French": "Disposition",
        "Spanish": "Disposición",
        "key": "Provision"
    },
    {
        "English": "already provisioned",
        "French": "déjà provisionné",
        "Spanish": "ya aprovisionado",
        "key": "already_provisioned"
    },
    {
        "English": "Please Select GreenShield provisioning choice.",
        "French": "Veuillez sélectionner le choix d'approvisionnement GreenShield.",
        "Spanish": "Seleccione la opción de aprovisionamiento GreenShield.",
        "key": "Please_Select_GreenShield_provisioning_choice"
    },
    {
        "English": "GreenShield Membership Id",
        "French": "Identifiant de membre GreenShield",
        "Spanish": "Identificación de membresía de GreenShield",
        "key": "GreenShield_Membership_Id"
    },
    {
        "English": "Please enter greenshield membership Id.",
        "French": "Veuillez saisir votre identifiant de membre greenshield.",
        "Spanish": "Ingrese el ID de membresía de Greenshield.",
        "key": "Please_enter_greenshield_membership_Id"
    },
    {
        "English": "The selection includes Equitable plans. Do you want to provision in Equitable?",
        "French": "La sélection comprend des plans Équitables. Souhaitez-vous provisionner en Equitable ?",
        "Spanish": "La selección incluye planes Equitable. ¿Quieres provisionar en Equitable?",
        "key": "The_selection_includes_Equitable_plans_Do_you_want_to_provision_in_Equitable"
    },
    {
        "English": "Please Select Equitable provisioning choice..",
        "French": "Veuillez sélectionner un choix d'approvisionnement équitable.",
        "Spanish": "Seleccione la opción de aprovisionamiento equitativo.",
        "key": "Please_Select_Equitable_provisioning_choice"
    },
    {
        "English": "Equitable Certifciate Id",
        "French": "Identifiant de certificat équitable",
        "Spanish": "Identificación del certificado equitativo",
        "key": "Equitable_Certifciate_Id"
    },
    {
        "English": "Please enter Equitable certificate Id.",
        "French": "Veuillez saisir l'ID du certificat Equitable.",
        "Spanish": "Introduzca el ID del certificado equitativo.",
        "key": "Please_enter_Equitable_certificate_Id"
    },
    {
        "English": "The selection includes Provincial Health Replacement Plan. Do you want to provision in Cowan?",
        "French": "La sélection comprend le Plan provincial de remplacement des soins de santé. Vous souhaitez vous approvisionner à Cowan ?",
        "Spanish": "La selección incluye Plan Provincial de Reposición de Salud. ¿Quieres aprovisionar en Cowan?",
        "key": "The_selection_includes_Provincial_Health_Replacement_Plan_Do_you_want_to_provision_in_Cowan"
    },
    {
        "English": "Please Select PHR provisioning choice.",
        "French": "Veuillez sélectionner le choix de provisionnement PHR.",
        "Spanish": "Seleccione la opción de aprovisionamiento de PHR.",
        "key": "Please_Select_PHR_provisioning_choice"
    },
    {
        "English": "PHR Membership Id",
        "French": "Identifiant de membre PHR",
        "Spanish": "Identificación de membresía de PHR",
        "key": "PHR_Membership_Id"
    },
    {
        "English": "Please enter PHR membership Id.",
        "French": "Veuillez saisir votre identifiant de membre PHR.",
        "Spanish": "Ingrese el ID de membresía de PHR.",
        "key": "Please_enter_PHR_membership_Id"
    },
    {
        "English": "The selection includes KixCare plans. Do you want to provision in KixCare?",
        "French": "La sélection comprend les plans KixCare. Vous souhaitez vous approvisionner dans KixCare ?",
        "Spanish": "La selección incluye planes KixCare. ¿Quieres aprovisionar en KixCare?",
        "key": "The_selection_includes_KixCare_plans_Do_you_want_to_provision_in_KixCare"
    },
    {
        "English": "Please Select KixCare provisioning choice..",
        "French": "Veuillez sélectionner le choix d'approvisionnement KixCare.",
        "Spanish": "Seleccione la opción de aprovisionamiento de KixCare.",
        "key": "Please_Select_KixCare_provisioning_choice"
    },
    {
        "English": "Send welcome email with Member Portal link upon successful enrollment?",
        "French": "Envoyer un e-mail de bienvenue avec le lien vers le portail des membres une fois l'inscription réussie ?",
        "Spanish": "¿Enviar un correo electrónico de bienvenida con el enlace al Portal para miembros tras una inscripción exitosa?",
        "key": "Send_welcome_email_with_Member_Portal_link_upon_successful_enrollment"
    },
    {
        "English": "Alternate Email",
        "French": "E-mail secondaire",
        "Spanish": "Correo electrónico alternativo",
        "key": "Alternate_Email"
    },
    {
        "English": "Please Select invitation mail choice",
        "French": "Veuillez sélectionner le choix de courrier d'invitation",
        "Spanish": "Seleccione la opción de correo de invitación",
        "key": "Please_Select_invitation_mail_choice"
    },
    {
        "English": "View Member",
        "French": "Afficher le membre",
        "Spanish": "Ver miembro",
        "key": "View_Member"
    },
    {
        "English": "Add Another Member",
        "French": "Ajouter un autre membre",
        "Spanish": "Agregar otro miembro",
        "key": "Add_Another_Member"
    },
    {
        "English": "Employee upgraded using payroll deduction",
        "French": "Employé reclassé grâce à la retenue sur salaire",
        "Spanish": "Empleado ascendido mediante deducción de nómina",
        "key": "Employee_upgraded_using_payroll_deduction"
    },
    {
        "English": "using payroll deduction",
        "French": "utiliser la retenue sur salaire",
        "Spanish": "usando la deducción de nómina",
        "key": "using_payroll_deduction"
    },
    {
        "English": "Employee upgraded using Direct payment",
        "French": "Employé reclassé grâce au paiement direct",
        "Spanish": "Empleado actualizado mediante pago directo",
        "key": "Employee_upgraded_using_Direct_payment"
    },
    {
        "English": "using Direct payment",
        "French": "en utilisant le paiement direct",
        "Spanish": "usando pago directo",
        "key": "using_Direct_payment"
    },
    {
        "English": "User Not Exists in Stax and Not in BMS",
        "French": "L'utilisateur n'existe pas dans Stax et pas dans BMS",
        "Spanish": "El usuario no existe en Stax ni en BMS",
        "key": "User_Not_Exists_in_Stax_and_Not_in_BMS"
    },
    {
        "English": "Please select all plan options",
        "French": "Veuillez sélectionner toutes les options du forfait",
        "Spanish": "Por favor seleccione todas las opciones del plan",
        "key": "Please_select_all_plan_options"
    },
    {
        "English": "No. of Children",
        "French": "Nombre d'enfants",
        "Spanish": "No. de niños",
        "key": "No_of_Children"
    },
    {
        "English": "Please add at least one child",
        "French": "Veuillez ajouter au moins un enfant",
        "Spanish": "Por favor agregue al menos un niño",
        "key": "Please_add_at_least_one_child"
    },
    {
        "English": "Do you have dependent children?",
        "French": "Avez-vous des enfants à charge ?",
        "Spanish": "¿Tiene hijos dependientes?",
        "key": "Do_you_have_dependent_children"
    },
    {
        "English": "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan.",
        "French": "Veuillez sélectionner un régime provincial de remplacement des soins de santé ainsi qu'un régime d'assurance maladie et dentaire.",
        "Spanish": "Seleccione un Plan Provincial de Reemplazo de Salud junto con un Plan de Seguro Médico y Dental.",
        "key": "Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan"
    },
    {
        "English": "File size is too large,maximum file size is 5MB",
        "French": "La taille du fichier est trop grande, la taille maximale du fichier est de 5 Mo.",
        "Spanish": "El tamaño del archivo es demasiado grande, el tamaño máximo del archivo es 5 MB",
        "key": "File_size_is_too_large_maximum_file_size_is_5MB"
    },
    {
        "English": "Please enter email Id.",
        "French": "Veuillez saisir votre identifiant de messagerie.",
        "Spanish": "Por favor ingrese el ID de correo electrónico.",
        "key": "Please_enter_email_Id"
    },
    {
        "English": "Age must be below 21 years",
        "French": "L'âge doit être inférieur à 21 ans",
        "Spanish": "La edad debe ser inferior a 21 años.",
        "key": "Age_must_be_below_21_years"
    },
    {
        "English": "Voluntary Plans (Premium paid 100% by employee directly)",
        "French": "Plans volontaires (prime payée à 100 % directement par l'employé)",
        "Spanish": "Planes Voluntarios (Prima pagada 100% directamente por el empleado)",
        "key": "Voluntary_Plans_Premium_paid_100_by_employee_directly"
    },
    {
        "English": "All selected plans summary",
        "French": "Récapitulatif de tous les forfaits sélectionnés",
        "Spanish": "Resumen de todos los planes seleccionados",
        "key": "All_selected_plans_summary"
    },
    {
        "English": "Enrolled full time in and attending an accredited college, university or educational institution.",
        "French": "Inscrit à temps plein et fréquentant un collège, une université ou un établissement d'enseignement accrédité.",
        "Spanish": "Inscrito a tiempo completo y asistiendo a un colegio, universidad o institución educativa acreditada.",
        "key": "Enrolled_full_time_in_and_attending_an_accredited_college_university_or_educational_institution"
    },
    {
        "English": "Coverage for disabled dependent children will be based on the definition in the specific insurer’s master contract. You will be contacted for additional information once your application has been received.",
        "French": "La couverture des enfants à charge handicapés sera basée sur la définition du contrat-cadre spécifique de l’assureur. Vous serez contacté pour des informations complémentaires une fois votre candidature reçue.",
        "Spanish": "La cobertura para hijos dependientes discapacitados se basará en la definición del contrato marco de la aseguradora específica. Se le contactará para obtener información adicional una vez que se haya recibido su solicitud.",
        "key": "Coverage_for_disabled_dependent_children_will_be_based_on_the_definition_in_the_specific_insurer_s_master_contract_You_will_be_contacted_for_additional_information_once_your_application_has_been_received"
    },
    {
        "English": "Invalid date",
        "French": "Date invalide",
        "Spanish": "Fecha no válida",
        "key": "Invalid_date"
    },
    {
        "English": "Province of Residence",
        "French": "Province de résidence",
        "Spanish": "Provincia de residencia",
        "key": "Province_of_Residence"
    },
    {
        "English": "No file choosen",
        "French": "Aucun fichier choisi",
        "Spanish": "No se ha elegido ningún archivo",
        "key": "No_file_choosen"
    },
    {
        "English": "Employer Name",
        "French": "Nom de l'employeur",
        "Spanish": "Nombre del empleador",
        "key": "Employer_Name"
    },
    {
        "English": "Please enter Employer Name",
        "French": "Veuillez entrer le nom de l'employeur",
        "Spanish": "Por favor ingrese el nombre del empleador",
        "key": "Please_enter_Employer_Name"
    },
    {
        "English": "Taxes included",
        "French": "Taxes incluses",
        "Spanish": "Impuestos incluidos",
        "key": "Taxes_included"
    },
    {
        "English": "Monthly premium",
        "French": "Prime mensuelle",
        "Spanish": "Prima mensual",
        "key": "Monthly_premium"
    },
    {
        "English": "Voluntary Opt-In",
        "French": "Inscription volontaire",
        "Spanish": "Inscripción voluntaria",
        "key": "Voluntary_Opt_In"
    },
    {
        "English": "Bank Code*",
        "French": "Code banque*",
        "Spanish": "Código bancario*",
        "key": "Bank_Code"
    },
    {
        "English": "Xclear",
        "French": "Xclair",
        "Spanish": "Xclaro",
        "key": "Xclear"
    },
    {
        "English": "Account No *",
        "French": "Numéro de compte *",
        "Spanish": "Número de cuenta *",
        "key": "Account_No"
    },
    {
        "English": "Verification Successful",
        "French": "Vérification réussie",
        "Spanish": "Verificación exitosa",
        "key": "Verification_Successful"
    },
    {
        "English": "Ok",
        "French": "D'accord",
        "Spanish": "De acuerdo",
        "key": "Ok"
    },
    {
        "English": "Invite Employees",
        "French": "Inviter des employés",
        "Spanish": "Invitar empleados",
        "key": "Invite_Employees"
    },
    {
        "English": "Download Contracts",
        "French": "Télécharger les contrats",
        "Spanish": "Descargar Contratos",
        "key": "Download_Contracts"
    },
    {
        "English": "Share General Invite link",
        "French": "Partager le lien d’invitation générale",
        "Spanish": "Compartir enlace de invitación general",
        "key": "Share_General_Invite_link"
    },
    {
        "English": "Invitation sent to employees.",
        "French": "Invitation envoyée aux salariés.",
        "Spanish": "Invitación enviada a los empleados.",
        "key": "Invitation_sent_to_employees"
    },
    {
        "English": "Plan Proposal sent to Corporate Plan Administrator",
        "French": "Proposition de régime envoyée à l'administrateur du régime d'entreprise",
        "Spanish": "Propuesta de plan enviada al administrador del plan corporativo",
        "key": "Plan_Proposal_sent_to_Corporate_Plan_Administrator"
    },
    {
        "English": "Done",
        "French": "Fait",
        "Spanish": "Hecho",
        "key": "Done"
    },
    {
        "English": "Please choose date of hire \n",
        "French": "Veuillez choisir la date de location \n",
        "Spanish": "Por favor elija la fecha de contratación \n",
        "key": "Please_choose_date_of_hire"
    },
    {
        "English": "Do you have dependent children?",
        "French": "Avez-vous des enfants à charge?",
        "Spanish": "¿Tiene hijos dependientes?",
        "key": "Do_you_have_dependent_children"
    },
    {
        "English": "No. of Children \n",
        "French": "Nombre d'enfants \n",
        "Spanish": "No. de niños \n",
        "key": "No_of_Children"
    },
    {
        "English": "Are you sure you want to delete? \n",
        "French": "Êtes-vous sûr de vouloir supprimer ? \n",
        "Spanish": "¿Estás seguro de que deseas eliminar? \n",
        "key": "Are_you_sure_you_want_to_delete"
    },
    {
        "English": "Monthly premium \nTaxes included",
        "French": "Prime mensuelle \nTaxes incluses",
        "Spanish": "Prima mensual \nImpuestos incluidos",
        "key": "Monthly_premium_Taxes_included"
    },
    {
        "English": "Do you have dependent children?",
        "French": "Avez-vous des enfants à charge?",
        "Spanish": "¿Tiene hijos dependientes?",
        "key": "Do_you_have_dependent_children"
    },
    {
        "English": "Please enter email Id. \n",
        "French": "Veuillez saisir votre identifiant de messagerie. \n",
        "Spanish": "Por favor ingrese el ID de correo electrónico. \n",
        "key": "Please_enter_email_Id"
    },
    {
        "English": "Alert \n",
        "French": "Alerte \n",
        "Spanish": "Alerta \n",
        "key": "Alert"
    },
    {
        "English": "No. of Children \n",
        "French": "Nombre d'enfants \n",
        "Spanish": "No. de niños \n",
        "key": "No_of_Children"
    },
    {
        "English": "Please choose date of hire \n",
        "French": "Veuillez choisir la date de location \n",
        "Spanish": "Por favor elija la fecha de contratación \n",
        "key": "Please_choose_date_of_hire"
    },
    {
        "English": "Enrolled full time in and attending an accredited college, university or educational institution. \n\n",
        "French": "Inscrit à temps plein et fréquentant un collège, une université ou un établissement d'enseignement accrédité. \n\n",
        "Spanish": "Inscrito a tiempo completo y asistiendo a un colegio, universidad o institución educativa acreditada. \n\n",
        "key": "Enrolled_full_time_in_and_attending_an_accredited_college_university_or_educational_institution"
    },
    {
        "English": "Coverage for disabled dependent children will be based on the definition in the specific insurer’s master contract. You will be contacted for additional information once your application has been received. \n\n",
        "French": "La couverture des enfants à charge handicapés sera basée sur la définition du contrat-cadre spécifique de l’assureur. Vous serez contacté pour des informations complémentaires une fois votre candidature reçue. \n\n",
        "Spanish": "La cobertura para hijos dependientes discapacitados se basará en la definición del contrato marco de la aseguradora específica. Se le contactará para obtener información adicional una vez que se haya recibido su solicitud. \n\n",
        "key": "Coverage_for_disabled_dependent_children_will_be_based_on_the_definition_in_the_specific_insurer_s_master_contract_You_will_be_contacted_for_additional_information_once_your_application_has_been_received"
    },
    {
        "English": "Coverage for disabled dependent children will be based on the definition in the specific insurer’s master contract. You will be contacted for additional information once your application has been received. \n\n",
        "French": "La couverture des enfants à charge handicapés sera basée sur la définition du contrat-cadre spécifique de l’assureur. Vous serez contacté pour des informations complémentaires une fois votre candidature reçue. \n\n",
        "Spanish": "La cobertura para hijos dependientes discapacitados se basará en la definición del contrato marco de la aseguradora específica. Se le contactará para obtener información adicional una vez que se haya recibido su solicitud. \n\n",
        "key": "Coverage_for_disabled_dependent_children_will_be_based_on_the_definition_in_the_specific_insurer_s_master_contract_You_will_be_contacted_for_additional_information_once_your_application_has_been_received"
    },
    {
        "English": "Enrolled full time in and attending an accredited college, university or educational institution. \n\n",
        "French": "Inscrit à temps plein et fréquentant un collège, une université ou un établissement d'enseignement accrédité. \n\n",
        "Spanish": "Inscrito a tiempo completo y asistiendo a un colegio, universidad o institución educativa acreditada. \n\n",
        "key": "Enrolled_full_time_in_and_attending_an_accredited_college_university_or_educational_institution"
    },
    {
        "English": "Are you sure you want to delete? \n",
        "French": "Êtes-vous sûr de vouloir supprimer ? \n",
        "Spanish": "¿Estás seguro de que deseas eliminar? \n",
        "key": "Are_you_sure_you_want_to_delete"
    },
    {
        "English": "Based on the information provided, you , your spouse mounty and your dependent(s) Mounty are eligible to apply for the following plans.",
        "French": "Sur la base des informations fournies, vous, votre conjoint Mounty et vos personnes à charge Mounty êtes admissibles aux régimes suivants.",
        "Spanish": "Según la información proporcionada, usted, su cónyuge Mounty y sus dependientes Mounty son elegibles para solicitar los siguientes planes.",
        "key": "Based_on_the_information_provided_you_your_spouse_mounty_and_your_dependent_s_Mounty_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Based on the information provided, you are eligible to apply for the following plans. ",
        "French": "Sur la base des informations fournies, vous êtes éligible pour postuler aux plans suivants. ",
        "Spanish": "Según la información proporcionada, usted es elegible para solicitar los siguientes planes. ",
        "key": "Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Beneficiary Information ",
        "French": "Informations sur le bénéficiaire ",
        "Spanish": "Información del beneficiario ",
        "key": "Beneficiary_Information"
    },
    {
        "English": "Monthly premium Taxes included",
        "French": "Prime mensuelle Taxes incluses",
        "Spanish": "Prima mensual Impuestos incluidos",
        "key": "Monthly_premium_Taxes_included"
    },
    {
        "English": "Alert ",
        "French": "Alerte ",
        "Spanish": "Alerta ",
        "key": "Alert"
    },
    {
        "English": "Please enter email Id. ",
        "French": "Veuillez saisir votre identifiant de messagerie. ",
        "Spanish": "Por favor ingrese el ID de correo electrónico. ",
        "key": "Please_enter_email_Id"
    },
    {
        "English": "Common Law",
        "French": "Common Law",
        "Spanish": "Ley común",
        "key": "Common_Law"
    },
    {
        "English": "Beneficiary",
        "French": "Bénéficiaire",
        "Spanish": "Beneficiario",
        "key": "Beneficiary"
    },
    {
        "English": "Please select beneficiary ",
        "French": "Veuillez sélectionner le bénéficiaire ",
        "Spanish": "Por favor seleccione beneficiario ",
        "key": "Please_select_beneficiary"
    },
    {
        "English": "Please select relationship",
        "French": "Veuillez sélectionner la relation",
        "Spanish": "Por favor seleccione relación",
        "key": "Please_select_relationship"
    },
    {
        "English": "Child",
        "French": "Enfant",
        "Spanish": "Niño",
        "key": "Child"
    },
    {
        "English": "Please enter percentage",
        "French": "Veuillez entrer un pourcentage",
        "Spanish": "Por favor ingrese el porcentaje",
        "key": "Please_enter_percentage"
    },
    {
        "English": "Percentage",
        "French": "Pourcentage",
        "Spanish": "Porcentaje",
        "key": "Percentage"
    },
    {
        "English": "Is this person under age 18*",
        "French": "Cette personne a-t-elle moins de 18 ans*",
        "Spanish": "¿Esta persona es menor de 18 años?*",
        "key": "Is_this_person_under_age_18"
    },
    {
        "English": "Contingent Last Name*",
        "French": "Nom de famille du contingent*",
        "Spanish": "Apellido contingente*",
        "key": "Contingent_Last_Name"
    },
    {
        "English": "Contingent First Name*",
        "French": "Prénom du contingent*",
        "Spanish": "Nombre contingente*",
        "key": "Contingent_First_Name"
    },
    {
        "English": "Distributed percentages must equal 100%, and not more",
        "French": "Les pourcentages distribués doivent être égaux à 100 % et pas plus",
        "Spanish": "Los porcentajes distribuidos deben ser iguales al 100% y no más.",
        "key": "Distributed_percentages_must_equal_100_and_not_more"
    },
    {
        "English": "Trustee First Name*",
        "French": "Prénom du fiduciaire*",
        "Spanish": "Nombre del administrador*",
        "key": "Trustee_First_Name"
    },
    {
        "English": "Trustee Last Name*",
        "French": "Nom du fiduciaire*",
        "Spanish": "Apellido del Fideicomisario*",
        "key": "Trustee_Last_Name"
    },
    {
        "English": "Percentage",
        "French": "Pourcentage",
        "Spanish": "Porcentaje",
        "key": "Percentage"
    },
    {
        "English": "Minor",
        "French": "Mineure",
        "Spanish": "Menor",
        "key": "Minor"
    },
    {
        "English": "Spouse Signature",
        "French": "Signature du conjoint",
        "Spanish": "Firma del cónyuge",
        "key": "Spouse_Signature"
    },
    {
        "English": "I confirm signing up for the benefits plan provided by the company",
        "French": "Je confirme mon adhésion au plan d'avantages sociaux proposé par l'entreprise",
        "Spanish": "Confirmo la inscripción al plan de beneficios proporcionado por la empresa",
        "key": "I_confirm_signing_up_for_the_benefits_plan_provided_by_the_company"
    },
    {
        "English": "Please confirm Company paid plans ",
        "French": "Veuillez confirmer les forfaits payants de l'entreprise ",
        "Spanish": "Confirme los planes pagos de la empresa ",
        "key": "Please_confirm_Company_paid_plans"
    },
    {
        "English": "I confirm enrolling into voluntary opt-ins and charge monthly premiums to Credit Card or PAD as per data below",
        "French": "Je confirme mon inscription aux inscriptions volontaires et je facture les primes mensuelles sur la carte de crédit ou le PAD selon les données ci-dessous.",
        "Spanish": "Confirmo que me inscribo en opciones voluntarias y cargo las primas mensuales a la tarjeta de crédito o PAD según los datos a continuación",
        "key": "I_confirm_enrolling_into_voluntary_opt_ins_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below"
    },
    {
        "English": "Voluntary Opt-ins Payment",
        "French": "Paiement des inscriptions volontaires",
        "Spanish": "Pago de suscripción voluntaria",
        "key": "Voluntary_Opt_ins_Payment"
    },
    {
        "English": "Please confirm voluntary plans",
        "French": "Veuillez confirmer les plans volontaires",
        "Spanish": "Por favor confirme los planes voluntarios.",
        "key": "Please_confirm_voluntary_plans"
    },
    {
        "English": "Please wait the enrollment is in process..",
        "French": "Veuillez patienter, l'inscription est en cours.",
        "Spanish": "Espere, la inscripción está en proceso.",
        "key": "Please_wait_the_enrollment_is_in_process"
    },
    {
        "English": "Thank you for your enrollment! Please check your inbox for your welcome email. Login to your Member Portal using the activation code in the welcome email and update the password.",
        "French": "Merci pour votre inscription ! Veuillez vérifier votre boîte de réception pour votre e-mail de bienvenue. Connectez-vous à votre portail membre en utilisant le code d'activation contenu dans l'e-mail de bienvenue et mettez à jour le mot de passe.",
        "Spanish": "¡Gracias por tu inscripción! Por favor revise su bandeja de entrada para recibir su correo electrónico de bienvenida. Inicie sesión en su Portal de miembros utilizando el código de activación en el correo electrónico de bienvenida y actualice la contraseña.",
        "key": "Thank_you_for_your_enrollment_Please_check_your_inbox_for_your_welcome_email_Login_to_your_Member_Portal_using_the_activation_code_in_the_welcome_email_and_update_the_password"
    },
    {
        "English": "Enrollment successful",
        "French": "Inscription réussie",
        "Spanish": "Inscripción exitosa",
        "key": "Enrollment_successful"
    },
    {
        "English": "Please select a Provincial Health Replacement Plan. ",
        "French": "Veuillez sélectionner un régime provincial de remplacement des soins de santé. ",
        "Spanish": "Por favor seleccione un Plan Provincial de Reemplazo de Salud. ",
        "key": "Please_select_a_Provincial_Health_Replacement_Plan"
    },
    {
        "English": "Please wait the enrollment is in process...",
        "French": "Veuillez patienter, l'inscription est en cours...",
        "Spanish": "Por favor espere la inscripción está en proceso...",
        "key": "Please_wait_the_enrollment_is_in_process"
    },
    {
        "English": "You are already done with the subscription.Please check your mail or contact admin@groupbenefitz.ca",
        "French": "Vous avez déjà terminé votre abonnement. Veuillez vérifier votre courrier ou contacter admin@groupbenefitz.ca",
        "Spanish": "Ya ha terminado con la suscripción. Revise su correo o comuníquese con admin@groupbenefitz.ca",
        "key": "You_are_already_done_with_the_subscription_Please_check_your_mail_or_contact_admin_groupbenefitz_ca"
    },
    {
        "English": "Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.",
        "French": "Désolé, le serveur est actuellement en maintenance. Veuillez réessayer plus tard. Nous nous excusons pour tout inconvénient.",
        "Spanish": "Lo sentimos, el servidor se encuentra actualmente en mantenimiento. Inténtelo de nuevo más tarde. Pedimos disculpas por cualquier inconveniente.",
        "key": "Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience"
    },
    {
        "English": "Company Name",
        "French": "Nom de l’entreprise",
        "Spanish": "Nombre de la empresa",
        "key": "Company_Name"
    },
    {
        "English": "Please read and agree to the terms & conditions",
        "French": "Veuillez lire et accepter les termes et conditions",
        "Spanish": "Por favor lea y acepte los términos y condiciones.",
        "key": "Please_read_and_agree_to_the_terms_conditions"
    },
    {
        "English": "Hours Per week",
        "French": "Heures par semaine",
        "Spanish": "Horas por semana",
        "key": "Hours_Per_week"
    },
    {
        "English": "Please read the advisor disclosure",
        "French": "Veuillez lire la divulgation du conseiller",
        "Spanish": "Lea la divulgación del asesor.",
        "key": "Please_read_the_advisor_disclosure"
    },
    {
        "English": "Please enter job title",
        "French": "Veuillez entrer le titre du poste",
        "Spanish": "Por favor ingrese el título del trabajo",
        "key": "Please_enter_job_title"
    },
    {
        "English": "Please enter company name",
        "French": "Veuillez entrer le nom de l'entreprise",
        "Spanish": "Por favor ingrese el nombre de la empresa",
        "key": "Please_enter_company_name"
    },
    {
        "English": "NHLAA ID",
        "French": "ID NHLAA",
        "Spanish": "ID NHLAA",
        "key": "NHLAA_ID"
    },
    {
        "English": "Please enter NHLAA ID",
        "French": "Veuillez entrer l'ID NHLAA",
        "Spanish": "Por favor ingrese el ID NHLAA",
        "key": "Please_enter_nhlaa_id"
    },
    {
        "English": "I have read the",
        "French": "j'ai lu le",
        "Spanish": "he leído el",
        "key": "I_have_read_the"
    },
    {
        "English": "Name As Shown On Provincial Health Card",
        "French": "Nom tel qu'indiqué sur la carte de santé provinciale",
        "Spanish": "Nombre que aparece en la tarjeta sanitaria provincial",
        "key": "Name_As_Shown_On_Provincial_Health_Card"
    },
    {
        "English": "Terms & Conditions",
        "French": "Conditions générales",
        "Spanish": "Términos y condiciones",
        "key": "Terms_Conditions"
    },
    {
        "English": "I have read and agree to the",
        "French": "J'ai lu et j'accepte le",
        "Spanish": "He leído y acepto las",
        "key": "I_have_read_and_agree_to_the"
    },
    {
        "English": "Advisor Disclosure",
        "French": "Divulgation du conseiller",
        "Spanish": "Divulgación del asesor",
        "key": "Advisor_Disclosure"
    },
    {
        "English": "Hi",
        "French": "Salut",
        "Spanish": "Hola",
        "key": "Hi"
    },
    {
        "English": "MEMBER",
        "French": "MEMBRE",
        "Spanish": "MIEMBRO",
        "key": "MEMBER"
    },
    {
        "English": "SPOUSE",
        "French": "CONJOINTE",
        "Spanish": "CÓNYUGE",
        "key": "SPOUSE"
    },
    {
        "English": "Please enter card Number",
        "French": "Veuillez entrer le numéro de la carte",
        "Spanish": "Por favor ingrese el número de tarjeta",
        "key": "Please_enter_card_Number"
    },
    {
        "English": "Please enter the correct Month and Year",
        "French": "Veuillez entrer le mois et l'année corrects",
        "Spanish": "Por favor ingrese el mes y año correctos",
        "key": "Please_enter_the_correct_Month_and_Year"
    },
    {
        "English": "Please enter valid card Number",
        "French": "Veuillez entrer un numéro de carte valide",
        "Spanish": "Por favor ingrese un número de tarjeta válido",
        "key": "Please_enter_valid_card_Number"
    },
    {
        "English": "Please Sign the Signature",
        "French": "Veuillez signer la signature",
        "Spanish": "Por favor firme la firma",
        "key": "Please_Sign_the_Signature"
    },
    {
        "English": "Please Check re-Captcha Validation",
        "French": "Veuillez vérifier la validation du re-Captcha",
        "Spanish": "Por favor verifique la validación de re-Captcha",
        "key": "Please_Check_re_Captcha_Validation"
    },
    {
        "English": "Select dependent Date of Arriaval",
        "French": "Sélectionnez la date d'arrivée dépendante",
        "Spanish": "Seleccione la fecha de llegada dependiente",
        "key": "Select_dependent_Date_of_Arriaval"
    },
    {
        "English": "Select dependent landed immigrant status",
        "French": "Sélectionnez le statut d'immigrant reçu à charge",
        "Spanish": "Seleccione el estatus de inmigrante dependiente y desembarcado",
        "key": "Select_dependent_landed_immigrant_status"
    },
    {
        "English": "Select dependent coverage",
        "French": "Sélectionnez la couverture des personnes à charge",
        "Spanish": "Seleccionar cobertura para dependientes",
        "key": "Select_dependent_coverage"
    },
    {
        "English": "Select dependent living status in Canada",
        "French": "Sélectionnez le statut de personne à charge au Canada",
        "Spanish": "Seleccione el estado de vida de dependiente en Canadá",
        "key": "Select_dependent_living_status_in_Canada"
    },
    {
        "English": "Select dependent apply landed immigrant",
        "French": "Sélectionnez une personne à charge postulez un immigrant reçu",
        "Spanish": "Seleccionar dependiente aplicar inmigrante desembarcado",
        "key": "Select_dependent_apply_landed_immigrant"
    },
    {
        "English": "Select dependent Country Origin",
        "French": "Sélectionnez le pays d'origine dépendant",
        "Spanish": "Seleccione el país de origen dependiente",
        "key": "Select_dependent_Country_Origin"
    },
    {
        "English": "Select employee date of arrival",
        "French": "Sélectionnez la date d'arrivée de l'employé",
        "Spanish": "Seleccione la fecha de llegada del empleado",
        "key": "Select_employee_date_of_arrival"
    },
    {
        "English": "Select employee immigrant status",
        "French": "Sélectionnez le statut d'immigrant de l'employé",
        "Spanish": "Seleccione el estatus de inmigrante del empleado",
        "key": "Select_employee_immigrant_status"
    },
    {
        "English": "Select employee apply landed status",
        "French": "Sélectionnez un employé et demandez le statut d'établissement",
        "Spanish": "Seleccionar empleado aplicar estado aterrizado",
        "key": "Select_employee_apply_landed_status"
    },
    {
        "English": "Select employee coverage",
        "French": "Sélectionnez la couverture des employés",
        "Spanish": "Seleccionar cobertura para empleados",
        "key": "Select_employee_coverage"
    },
    {
        "English": "Select employee country of origin",
        "French": "Sélectionnez le pays d'origine de l'employé",
        "Spanish": "Seleccione el país de origen del empleado",
        "key": "Select_employee_country_of_origin"
    },
    {
        "English": "Select Plan Enrollment Date",
        "French": "Sélectionnez la date d'adhésion au plan",
        "Spanish": "Seleccione la fecha de inscripción del plan",
        "key": "Select_Plan_Enrollment_Date"
    },
    {
        "English": "Enter First Name",
        "French": "Entrez le prénom",
        "Spanish": "Introduzca el nombre",
        "key": "Enter_First_Name"
    },
    {
        "English": "Enter Last Name",
        "French": "Entrez le nom de famille",
        "Spanish": "Ingrese el apellido",
        "key": "Enter_Last_Name"
    },
    {
        "English": "Enter Email",
        "French": "Entrez l'e-mail",
        "Spanish": "Ingrese el correo electrónico",
        "key": "Enter_Email"
    },
    {
        "English": "Enter Phone Number",
        "French": "Entrez le numéro de téléphone",
        "Spanish": "Ingrese el número de teléfono",
        "key": "Enter_Phone_Number"
    },
    {
        "English": "Enter Street Address",
        "French": "Entrez l'adresse postale",
        "Spanish": "Introduzca la dirección",
        "key": "Enter_Street_Address"
    },
    {
        "English": "Enter City",
        "French": "Entrez la ville",
        "Spanish": "Ingrese la ciudad",
        "key": "Enter_City"
    },
    {
        "English": "Select Province of Residence",
        "French": "Sélectionnez la province de résidence",
        "Spanish": "Seleccione Provincia de Residencia",
        "key": "Select_Province_of_Residence"
    },
    {
        "English": "Select Province of Employment",
        "French": "Sélectionnez la province d'emploi",
        "Spanish": "Seleccione Provincia de Empleo",
        "key": "Select_Province_of_Employment"
    },
    {
        "English": "Enter Postal Code",
        "French": "Entrez le code postal",
        "Spanish": "Ingrese el código postal",
        "key": "Enter_Postal_Code"
    },
    {
        "English": "Select Gender",
        "French": "Sélectionnez le sexe",
        "Spanish": "Seleccione Género",
        "key": "Select_Gender"
    },
    {
        "English": "Select Date of hire",
        "French": "Sélectionnez la date d'embauche",
        "Spanish": "Seleccione Fecha de contratación",
        "key": "Select_Date_of_hire"
    },
    {
        "English": "Select Date of birth",
        "French": "Sélectionnez la date de naissance",
        "Spanish": "Seleccione Fecha de nacimiento",
        "key": "Select_Date_of_birth"
    },
    {
        "English": "Enter Company Name",
        "French": "Entrez le nom de l'entreprise",
        "Spanish": "Introduzca el nombre de la empresa",
        "key": "Enter_Company_Name"
    },
    {
        "English": "Enter Job Title",
        "French": "Entrez le titre du poste",
        "Spanish": "Ingrese el título del trabajo",
        "key": "Enter_Job_Title"
    },
    {
        "English": "Enter Hours per week",
        "French": "Entrez les heures par semaine",
        "Spanish": "Ingrese Horas por semana",
        "key": "Enter_Hours_per_week"
    },
    {
        "English": "Choose work hours status",
        "French": "Choisir le statut des heures de travail",
        "Spanish": "Elija el estado de las horas de trabajo",
        "key": "Choose_work_hours_status"
    },
    {
        "English": "Choose Health Card status",
        "French": "Choisir le statut de la carte Santé",
        "Spanish": "Elija el estado de la Tarjeta Sanitaria",
        "key": "Choose_Health_Card_status"
    },
    {
        "English": "Choose Spouse status",
        "French": "Choisissez le statut de conjoint",
        "Spanish": "Elija el estado del cónyuge",
        "key": "Choose_Spouse_status"
    },
    {
        "English": "Enter Spouse First Name",
        "French": "Entrez le prénom du conjoint",
        "Spanish": "Ingrese el nombre del cónyuge",
        "key": "Enter_Spouse_First_Name"
    },
    {
        "English": "Enter Spouse Last Name",
        "French": "Entrez le nom de famille du conjoint",
        "Spanish": "Ingrese el apellido del cónyuge",
        "key": "Enter_Spouse_Last_Name"
    },
    {
        "English": "Select Spouse Gender",
        "French": "Sélectionnez le sexe du conjoint",
        "Spanish": "Seleccione el sexo del cónyuge",
        "key": "Select_Spouse_Gender"
    },
    {
        "English": "Enter Spouse Email",
        "French": "Entrez l'adresse e-mail du conjoint",
        "Spanish": "Ingrese el correo electrónico de su cónyuge",
        "key": "Enter_Spouse_Email"
    },
    {
        "English": "Select Spouse Date of birth",
        "French": "Sélectionnez la date de naissance du conjoint",
        "Spanish": "Seleccione Cónyuge Fecha de nacimiento",
        "key": "Select_Spouse_Date_of_birth"
    },
    {
        "English": "Choose Spouse Insurance status",
        "French": "Choisir le statut d'assurance du conjoint",
        "Spanish": "Elija el estado del seguro del cónyuge",
        "key": "Choose_Spouse_Insurance_status"
    },
    {
        "English": "Choose Dependent Children status",
        "French": "Choisir le statut d'enfant à charge",
        "Spanish": "Elija el estado de hijos dependientes",
        "key": "Choose_Dependent_Children_status"
    },
    {
        "English": "Enter Spouse name of Carrier",
        "French": "Entrez le nom du conjoint du transporteur",
        "Spanish": "Ingrese el nombre del cónyuge del transportista",
        "key": "Enter_Spouse_name_of_Carrier"
    },
    {
        "English": "Select Spouse COB",
        "French": "Sélectionnez le conjoint COB",
        "Spanish": "Seleccione Cónyuge COB",
        "key": "Select_Spouse_COB"
    },
    {
        "English": "Select Terms and Conditions",
        "French": "Sélectionnez les termes et conditions",
        "Spanish": "Seleccionar Términos y Condiciones",
        "key": "Select_Terms_and_Conditions"
    },
    {
        "English": "Select Advisor Disclosure",
        "French": "Sélectionnez la divulgation du conseiller",
        "Spanish": "Seleccione la divulgación del asesor",
        "key": "Select_Advisor_Disclosure"
    },
    {
        "English": "Critical Illness Insurance",
        "French": "Assurance maladies graves",
        "Spanish": "Seguro de enfermedades críticas",
        "key": "Critical_Illness_Insurance"
    },
    {
        "English": "Important Limitation applies for the first 24 months of this coverage:",
        "French": "Des limitations importantes s'appliquent pendant les 24 premiers mois de cette couverture :",
        "Spanish": "Importante Limitación aplica durante los primeros 24 meses de esta cobertura:",
        "key": "Important_Limitation_applies_for_the_first_24_months_of_this_coverage"
    },
    {
        "English": "Life Insurance",
        "French": "Assurance vie",
        "Spanish": "Seguro de vida",
        "key": "Life_Insurance"
    },
    {
        "English": "If the cause of death is non-accidental, no benefit will be paid but premiums will be refunded with 5% interest compounded annually . This limitation is removed if the insured Employee or Spouse subsequently apply and are approved for additional life coverage requiring evidence of insurability\n\nDeath from suicide within 24 months of the effective date of an insured person’s coverage is excluded",
        "French": "Si la cause du décès n’est pas accidentelle, aucune prestation ne sera versée mais les primes seront remboursées avec un intérêt de 5 % composé annuellement. Cette limitation est supprimée si l'employé ou le conjoint assuré présente par la suite une demande et est approuvé pour une couverture vie supplémentaire exigeant une preuve d'assurabilité.\n\nLe décès par suicide dans les 24 mois suivant la date d’entrée en vigueur de la couverture d’une personne assurée est exclu.",
        "Spanish": "Si la causa de la muerte no es accidental, no se pagará ningún beneficio pero las primas se reembolsarán con un interés del 5% compuesto anualmente. Esta limitación se elimina si el Empleado o Cónyuge asegurado posteriormente solicita y es aprobado para cobertura de vida adicional que requiere evidencia de asegurabilidad.\n\nSe excluye la muerte por suicidio dentro de los 24 meses siguientes a la fecha de entrada en vigor de la cobertura de una persona asegurada.",
        "key": "If_the_cause_of_death_is_non_accidental_no_benefit_will_be_paid_but_premiums_will_be_refunded_with_5_interest_compounded_annually_This_limitation_is_removed_if_the_insured_Employee_or_Spouse_subsequently_apply_and_are_approved_for_additional_life_coverage_requiring_evidence_of_insurability_Death_from_suicide_within_24_months_of_the_effective_date_of_an_insured_person_s_coverage_is_excluded"
    },
    {
        "English": "Please verify the bank details",
        "French": "Veuillez vérifier les coordonnées bancaires",
        "Spanish": "Por favor verifique los datos bancarios",
        "key": "Please_verify_the_bank_details"
    },
    {
        "English": "This pre-existing condition exclusion is removed if the insured Employee subsequently applies and is approved for additional critical illness coverage requiring evidence of insurability.\n",
        "French": "Cette exclusion relative aux affections préexistantes est supprimée si l'employé assuré présente par la suite une demande et est approuvé pour une couverture supplémentaire contre les maladies graves exigeant une preuve d'assurabilité.\n",
        "Spanish": "Esta exclusión de condición preexistente se elimina si el Empleado asegurado posteriormente solicita y es aprobado para cobertura adicional de enfermedad crítica que requiere evidencia de asegurabilidad.\n",
        "key": "This_pre_existing_condition_exclusion_is_removed_if_the_insured_Employee_subsequently_applies_and_is_approved_for_additional_critical_illness_coverage_requiring_evidence_of_insurability"
    },
    {
        "English": "Please select minor status",
        "French": "Veuillez sélectionner le statut mineur",
        "Spanish": "Por favor seleccione estado menor",
        "key": "Please_select_minor_status"
    },
    {
        "English": "Pre-existing Condition Exclusion applies for the first 24 months of this coverage: Any symptom, condition, disorder, illness, pre-disease or disease, or any mental, nervous or psychiatric condition or disorder for which any one of medical advice, treatment, service, prescribed medication, diagnosis or consultation, including consultation to investigate and/or diagnose (where diagnosis has not yet been made) was received by the insured or would have been received by a prudent individual within the 24 months immediately preceding the effective date.\n",
        "French": "L'exclusion des affections préexistantes s'applique pendant les 24 premiers mois de cette couverture : tout symptôme, affection, trouble, maladie, pré-maladie ou affection, ou tout état ou trouble mental, nerveux ou psychiatrique pour lequel un avis médical, un traitement, service, médicament prescrit, diagnostic ou consultation, y compris une consultation pour enquêter et/ou diagnostiquer (lorsque le diagnostic n'a pas encore été posé) a été reçu par l'assuré ou aurait été reçu par une personne prudente dans les 24 mois précédant immédiatement la date d'entrée en vigueur.\n",
        "Spanish": "La exclusión de condiciones preexistentes se aplica durante los primeros 24 meses de esta cobertura: Cualquier síntoma, condición, trastorno, enfermedad, preenfermedad o enfermedad, o cualquier condición o trastorno mental, nervioso o psiquiátrico para el cual cualquiera de los consejos, tratamientos, servicio, medicamento recetado, diagnóstico o consulta, incluida la consulta para investigar y/o diagnosticar (cuando aún no se haya realizado el diagnóstico) fue recibido por el asegurado o habría sido recibido por una persona prudente dentro de los 24 meses inmediatamente anteriores a la fecha de vigencia.\n",
        "key": "Pre_existing_Condition_Exclusion_applies_for_the_first_24_months_of_this_coverage_Any_symptom_condition_disorder_illness_pre_disease_or_disease_or_any_mental_nervous_or_psychiatric_condition_or_disorder_for_which_any_one_of_medical_advice_treatment_service_prescribed_medication_diagnosis_or_consultation_including_consultation_to_investigate_and_or_diagnose_where_diagnosis_has_not_yet_been_made_was_received_by_the_insured_or_would_have_been_received_by_a_prudent_individual_within_the_24_months_immediately_preceding_the_effective_date"
    },
    {
        "English": "Account Number must be 5-12 digits.",
        "French": "Le numéro de compte doit comporter de 5 à 12 chiffres.",
        "Spanish": "El número de cuenta debe tener entre 5 y 12 dígitos.",
        "key": "Account_Number_must_be_5_12_digits"
    },
    {
        "English": "Missing Information",
        "French": "Informations manquantes",
        "Spanish": "Información faltante",
        "key": "Missing_Information"
    },
    {
        "English": "Reset",
        "French": "Réinitialiser",
        "Spanish": "Restablecer",
        "key": "Reset"
    },
    {
        "English": "Please Upload Void Cheque file",
        "French": "Veuillez télécharger le fichier de chèque annulé",
        "Spanish": "Por favor cargue el archivo de verificación anulada",
        "key": "Please_Upload_Void_Cheque_file"
    },
    {
        "English": "Units",
        "French": "Unités",
        "Spanish": "Unidades",
        "key": "Units"
    },
    {
        "English": "Guarantee Acceptance",
        "French": "Acceptation de la garantie",
        "Spanish": "Aceptación de Garantía",
        "key": "Guarantee_Acceptance"
    },
    {
        "English": "Acceptance pending approval",
        "French": "Acceptation en attente d'approbation",
        "Spanish": "Aceptación pendiente de aprobación",
        "key": "Acceptance_pending_approval"
    },
    {
        "English": "Personal Information",
        "French": "Informations personnelles",
        "Spanish": "Información personal",
        "key": "Personal_Information"
    },
    {
        "English": "Monthly premium \n",
        "French": "Prime mensuelle \n",
        "Spanish": "Prima mensual \n",
        "key": "Monthly_premium"
    },
    {
        "English": "File size is too large,maximum file size is 1MB",
        "French": "La taille du fichier est trop grande, la taille maximale du fichier est de 1 Mo",
        "Spanish": "El tamaño del archivo es demasiado grande, el tamaño máximo del archivo es 1 MB",
        "key": "File_size_is_too_large_maximum_file_size_is_1MB"
    },
    {
        "English": "Enter Bank Number",
        "French": "Entrez le numéro de banque",
        "Spanish": "Ingrese el número de banco",
        "key": "Enter_Bank_Number"
    },
    {
        "English": "Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for your inconvenience.",
        "French": "Désolé, le serveur est actuellement en maintenance. Veuillez réessayer plus tard. Nous nous excusons pour votre inconvénient.",
        "Spanish": "Lo sentimos, el servidor se encuentra actualmente en mantenimiento. Inténtelo de nuevo más tarde. Nos disculpamos por las molestias.",
        "key": "Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_your_inconvenience"
    },
    {
        "English": "Enter Transit Number",
        "French": "Entrez le numéro de transit",
        "Spanish": "Ingrese el número de tránsito",
        "key": "Enter_Transit_Number"
    },
    {
        "English": "Select Province",
        "French": "Sélectionnez une province",
        "Spanish": "Seleccionar Provincia",
        "key": "Select_Province"
    },
    {
        "English": "If the cause of death is non-accidental, no benefit will be paid but premiums will be refunded with 5% interest compounded annually . This limitation is removed if the insured Employee or Spouse subsequently apply and are approved for additional life coverage requiring evidence of insurability",
        "French": "Si la cause du décès n’est pas accidentelle, aucune prestation ne sera versée mais les primes seront remboursées avec un intérêt de 5 % composé annuellement. Cette limitation est supprimée si l'employé ou le conjoint assuré présente par la suite une demande et est approuvé pour une couverture vie supplémentaire exigeant une preuve d'assurabilité.",
        "Spanish": "Si la causa de la muerte no es accidental, no se pagará ningún beneficio, pero las primas se reembolsarán con un interés del 5 % compuesto anualmente. Esta limitación se elimina si el Empleado o Cónyuge asegurado posteriormente solicita y es aprobado para cobertura de vida adicional que requiere evidencia de asegurabilidad.",
        "key": "If_the_cause_of_death_is_non_accidental_no_benefit_will_be_paid_but_premiums_will_be_refunded_with_5_interest_compounded_annually_This_limitation_is_removed_if_the_insured_Employee_or_Spouse_subsequently_apply_and_are_approved_for_additional_life_coverage_requiring_evidence_of_insurability"
    },
    {
        "English": "Enter Account Number",
        "French": "Entrez le numéro de compte",
        "Spanish": "Ingrese el número de cuenta",
        "key": "Enter_Account_Number"
    },
    {
        "English": "Verify the bank details",
        "French": "Vérifier les coordonnées bancaires",
        "Spanish": "Verificar los datos bancarios",
        "key": "Verify_the_bank_details"
    },
    {
        "English": "Uplaod VoidCheck",
        "French": "Télécharger VoidCheck",
        "Spanish": "Uplaod VoidCheck",
        "key": "Uplaod_VoidCheck"
    },
    {
        "English": "Select Recaptcha",
        "French": "Sélectionnez Recaptcha",
        "Spanish": "Seleccione Recaptcha",
        "key": "Select_Recaptcha"
    },
    {
        "English": "Death from suicide within 24 months of the effective date of an insured person’s coverage is excluded",
        "French": "Le décès par suicide dans les 24 mois suivant la date d’entrée en vigueur de la couverture d’une personne assurée est exclu.",
        "Spanish": "Se excluye la muerte por suicidio dentro de los 24 meses siguientes a la fecha de entrada en vigor de la cobertura de una persona asegurada.",
        "key": "Death_from_suicide_within_24_months_of_the_effective_date_of_an_insured_person_s_coverage_is_excluded"
    },
    {
        "English": "Member & Spouse",
        "French": "Membre et conjoint",
        "Spanish": "Miembro y cónyuge",
        "key": "Member_Spouse"
    },
    {
        "English": "Monthly premium\n",
        "French": "Prime mensuelle\n",
        "Spanish": "Prima mensual\n",
        "key": "Monthly_premium"
    },
    {
        "English": "Based on the information provided, you , your spouse and your dependent(s) are eligible to apply for the following plans.",
        "French": "Selon les informations fournies, vous, votre conjoint et les personnes à votre charge êtes admissibles aux régimes suivants.",
        "Spanish": "Según la información proporcionada, usted, su cónyuge y sus dependientes son elegibles para solicitar los siguientes planes.",
        "key": "Based_on_the_information_provided_you_your_spouse_and_your_dependent_s_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "and your dependent(s)",
        "French": "et vos personnes à charge",
        "Spanish": "y sus dependientes",
        "key": "and_your_dependent_s"
    },
    {
        "English": "Based on the information provided, you and your dependent(s)",
        "French": "Sur la base des informations fournies, vous et les personnes à votre charge",
        "Spanish": "Según la información proporcionada, usted y sus dependientes",
        "key": "Based_on_the_information_provided_you_and_your_dependent_s"
    },
    {
        "English": "are eligible to apply for the following plans.",
        "French": "sont éligibles pour postuler aux plans suivants.",
        "Spanish": "son elegibles para solicitar los siguientes planes.",
        "key": "are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Please confirm Company paid plans \n",
        "French": "Veuillez confirmer les forfaits payants de l'entreprise \n",
        "Spanish": "Confirme los planes pagos de la empresa \n",
        "key": "Please_confirm_Company_paid_plans"
    },
    {
        "English": "Based on the information provided, you , your spouse",
        "French": "Sur la base des informations fournies, vous, votre conjoint",
        "Spanish": "Según la información proporcionada, usted, su cónyuge",
        "key": "Based_on_the_information_provided_you_your_spouse"
    },
    {
        "English": "Please select a Provincial Health Replacement Plan. \n",
        "French": "Veuillez sélectionner un régime provincial de remplacement des soins de santé. \n",
        "Spanish": "Por favor seleccione un Plan Provincial de Reemplazo de Salud. \n",
        "key": "Please_select_a_Provincial_Health_Replacement_Plan"
    },
    {
        "English": "Based on the information provided, you are eligible to apply for the following plans.",
        "French": "Sur la base des informations fournies, vous êtes éligible pour postuler aux plans suivants.",
        "Spanish": "Según la información proporcionada, usted es elegible para solicitar los siguientes planes.",
        "key": "Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Beneficiary Information \n",
        "French": "Informations sur le bénéficiaire \n",
        "Spanish": "Información del beneficiario \n",
        "key": "Beneficiary_Information"
    },
    {
        "English": "Please select beneficiary \n",
        "French": "Veuillez sélectionner le bénéficiaire \n",
        "Spanish": "Por favor seleccione beneficiario \n",
        "key": "Please_select_beneficiary"
    },
    {
        "English": "Based on the information provided, you , your spouse",
        "French": "Sur la base des informations fournies, vous, votre conjoint",
        "Spanish": "Según la información proporcionada, usted, su cónyuge",
        "key": "Based_on_the_information_provided_you_your_spouse"
    },
    {
        "English": "and your dependent(s)",
        "French": "et vos personnes à charge",
        "Spanish": "y sus dependientes",
        "key": "and_your_dependent_s"
    },
    {
        "English": "Based on the information provided, you and your dependent(s)",
        "French": "Sur la base des informations fournies, vous et les personnes à votre charge",
        "Spanish": "Según la información proporcionada, usted y sus dependientes",
        "key": "Based_on_the_information_provided_you_and_your_dependent_s"
    },
    {
        "English": "are eligible to apply for the following plans.",
        "French": "sont éligibles pour postuler aux plans suivants.",
        "Spanish": "son elegibles para solicitar los siguientes planes.",
        "key": "are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Based on the information provided, you and your dependent(s)",
        "French": "Sur la base des informations fournies, vous et les personnes à votre charge",
        "Spanish": "Según la información proporcionada, usted y sus dependientes",
        "key": "Based_on_the_information_provided_you_and_your_dependent_s"
    },
    {
        "English": "Expiry month",
        "French": "Mois d'expiration",
        "Spanish": "Mes de vencimiento",
        "key": "Expiry_month"
    },
    {
        "English": "Based on the information provided, you are eligible to apply for the following plans.",
        "French": "Sur la base des informations fournies, vous êtes éligible pour postuler aux plans suivants.",
        "Spanish": "Según la información proporcionada, usted es elegible para solicitar los siguientes planes.",
        "key": "Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Based on the information provided,you,your spouse and your dependent(S)",
        "French": "Sur la base des informations fournies, vous, votre conjoint et votre (vos) personne(s) à charge",
        "Spanish": "Según la información proporcionada, usted, su cónyuge y su(s) dependiente(s)",
        "key": "Based_on_the_information_provided_you_your_spouse_and_your_dependent_S"
    },
    {
        "English": "Based on the information provided, you,your spouse and your dependent(S) are eligible to apply for the following plans.",
        "French": "Sur la base des informations fournies, vous, votre conjoint et les personnes à votre charge êtes éligibles pour postuler aux régimes suivants.",
        "Spanish": "Según la información proporcionada, usted, su cónyuge y sus dependientes son elegibles para solicitar los siguientes planes.",
        "key": "Based_on_the_information_provided_you_your_spouse_and_your_dependent_S_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Please Select Expiry Month",
        "French": "Veuillez sélectionner le mois d'expiration",
        "Spanish": "Seleccione el mes de vencimiento",
        "key": "Please_Select_Expiry_Month"
    },
    {
        "English": "Please Select Expiry Year",
        "French": "Veuillez sélectionner l'année d'expiration",
        "Spanish": "Seleccione el año de vencimiento",
        "key": "Please_Select_Expiry_Year"
    },
    {
        "English": "Taxes Included",
        "French": "Taxes incluses",
        "Spanish": "Impuestos incluidos",
        "key": "Taxes_Included"
    },
    {
        "English": "Please choose date of hire",
        "French": "Veuillez choisir la date d’embauche",
        "Spanish": "Por favor, elija la fecha de contratación",
        "key": "Please_choose_date_of_hire"
    },
    {
        "English": "Based on the information provided, you , your spouse",
        "French": "Sur la base des informations fournies, vous, votre conjoint",
        "Spanish": "Según la información proporcionada, usted, su cónyuge",
        "key": "Based_on_the_information_provided_you_your_spouse"
    },
    {
        "English": "and your dependent(s)",
        "French": "et vos personnes à charge",
        "Spanish": "y sus dependientes",
        "key": "and_your_dependent_s"
    },
    {
        "English": "Based on the information provided, you and your dependent(s)",
        "French": "Sur la base des informations fournies, vous et les personnes à votre charge",
        "Spanish": "Según la información proporcionada, usted y sus dependientes",
        "key": "Based_on_the_information_provided_you_and_your_dependent_s"
    },
    {
        "English": "are eligible to apply for the following plans.",
        "French": "sont éligibles pour postuler aux plans suivants.",
        "Spanish": "son elegibles para solicitar los siguientes planes.",
        "key": "are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Based on the information provided, you are eligible to apply for the following plans.",
        "French": "Sur la base des informations fournies, vous êtes éligible pour postuler aux plans suivants.",
        "Spanish": "Según la información proporcionada, usted es elegible para solicitar los siguientes planes.",
        "key": "Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "If the cause of death is non-accidental, no benefit will be paid but premiums will be refunded with 5% interest compounded annually . This limitation is removed if the insured Employee or Spouse subsequently apply and are approved for additional life coverage requiring evidence of insurability\n\n",
        "French": "Si la cause du décès n’est pas accidentelle, aucune prestation ne sera versée mais les primes seront remboursées avec un intérêt de 5 % composé annuellement. Cette limitation est supprimée si l'employé ou le conjoint assuré présente par la suite une demande et est approuvé pour une couverture vie supplémentaire exigeant une preuve d'assurabilité.\n\n",
        "Spanish": "Si la causa de la muerte no es accidental, no se pagará ningún beneficio pero las primas se reembolsarán con un interés del 5% compuesto anualmente. Esta limitación se elimina si el Empleado o Cónyuge asegurado posteriormente solicita y es aprobado para cobertura de vida adicional que requiere evidencia de asegurabilidad.\n\n",
        "key": "If_the_cause_of_death_is_non_accidental_no_benefit_will_be_paid_but_premiums_will_be_refunded_with_5_interest_compounded_annually_This_limitation_is_removed_if_the_insured_Employee_or_Spouse_subsequently_apply_and_are_approved_for_additional_life_coverage_requiring_evidence_of_insurability"
    },
    {
        "English": "If the cause of death is non-accidental, no benefit will be paid but premiums will be refunded with 5% interest compounded annually . This limitation is removed if the insured Employee or Spouse subsequently apply and are approved for additional life coverage requiring evidence of insurability\n\n",
        "French": "Si la cause du décès n’est pas accidentelle, aucune prestation ne sera versée mais les primes seront remboursées avec un intérêt de 5 % composé annuellement. Cette limitation est supprimée si l'employé ou le conjoint assuré présente par la suite une demande et est approuvé pour une couverture vie supplémentaire exigeant une preuve d'assurabilité.\n\nLe décès par suicide dans les 24 mois suivant la date d’entrée en vigueur de la couverture d’une personne assurée est exclu.",
        "Spanish": "Si la causa de la muerte no es accidental, no se pagará ningún beneficio pero las primas se reembolsarán con un interés del 5% compuesto anualmente. Esta limitación se elimina si el Empleado o Cónyuge asegurado posteriormente solicita y es aprobado para cobertura de vida adicional que requiere evidencia de asegurabilidad.\n\nSe excluye la muerte por suicidio dentro de los 24 meses siguientes a la fecha de entrada en vigor de la cobertura de una persona asegurada.",
        "key": "If_the_cause_of_death_is_non_accidental_no_benefit_will_be_paid_but_premiums_will_be_refunded_with_5_interest_compounded_annually_This_limitation_is_removed_if_the_insured_Employee_or_Spouse_subsequently_apply_and_are_approved_for_additional_life_coverage_requiring_evidence_of_insurability"
    },
    {
        "English": "Please check the PAD agreement",
        "French": "Veuillez vérifier l'accord PAD",
        "Spanish": "Por favor consulte el acuerdo PAD",
        "key": "Please_check_the_PAD_agreement"
    },
    {
        "English": "Please check the Plan Selection Page",
        "French": "Veuillez consulter la page de sélection du plan",
        "Spanish": "Por favor consulte la página de selección de planes",
        "key": "Please_check_the_Plan_Selection_Page"
    },
    {
        "English": "Are you sure you want to delete this Benficiary?",
        "French": "Êtes-vous sûr de vouloir supprimer ce bénéficiaire ?",
        "Spanish": "¿Estás seguro de que deseas eliminar este Beneficiario?",
        "key": "Are_you_sure_you_want_to_delete_this_Benficiary"
    },
    {
        "English": "Please ensure the graduation date is greater than the date of birth",
        "French": "Veuillez vous assurer que la date d'obtention du diplôme est supérieure à la date de naissance",
        "Spanish": "Asegúrese de que la fecha de graduación sea mayor que la fecha de nacimiento.",
        "key": "Please_ensure_the_graduation_date_is_greater_than_the_date_of_birth"
    },
    {
        "English": "Please select health card option",
        "French": "Veuillez sélectionner l'option de carte de santé",
        "Spanish": "Por favor seleccione la opción tarjeta sanitaria",
        "key": "Please_select_health_card_option"
    },
    {
        "English": "Based on the information provided, you are eligible to apply for the following plans. \n",
        "French": "Sur la base des informations fournies, vous êtes éligible pour postuler aux plans suivants. \n",
        "Spanish": "Según la información proporcionada, usted es elegible para solicitar los siguientes planes. \n",
        "key": "Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans"
    },
    {
        "English": "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan.\n\n",
        "French": "Veuillez sélectionner un régime provincial de remplacement des soins de santé ainsi qu'un régime d'assurance maladie et dentaire.\n\n",
        "Spanish": "Seleccione un Plan Provincial de Reemplazo de Salud junto con un Plan de Seguro Médico y Dental.\n\n",
        "key": "Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan"
    },
    {
        "English": "Enter valid postal code",
        "French": "Entrez un code postal valide",
        "Spanish": "Introduce un código postal válido",
        "key": "Enter_valid_postal_code"
    },
    {
        "English": "Do you have dependent children?",
        "French": "Avez-vous des enfants à charge?",
        "Spanish": "¿Tiene hijos dependientes?",
        "key": "Do_you_have_dependent_children"
    },
    {
        "English": "Do you have dependent children?",
        "French": "Avez-vous des enfants à charge?",
        "Spanish": "¿Tiene hijos dependientes?",
        "key": "Do_you_have_dependent_children"
    },
    {
        "English": "Please confirm Company paid plans",
        "French": "Veuillez confirmer les forfaits payants de l'entreprise",
        "Spanish": "Confirme los planes pagos de la empresa",
        "key": "Please_confirm_Company_paid_plans"
    },
    {
        "English": "Please select beneficiary",
        "French": "Veuillez sélectionner le bénéficiaire",
        "Spanish": "Por favor seleccione beneficiario",
        "key": "Please_select_beneficiary"
    },
    {
        "English": "This pre-existing condition exclusion is removed if the insured Employee subsequently applies and is approved for additional critical illness coverage requiring evidence of insurability.",
        "French": "Cette exclusion relative aux affections préexistantes est supprimée si l'employé assuré présente par la suite une demande et est approuvé pour une couverture supplémentaire contre les maladies graves exigeant une preuve d'assurabilité.",
        "Spanish": "Esta exclusión de condición preexistente se elimina si el Empleado asegurado posteriormente solicita y es aprobado para cobertura adicional de enfermedad crítica que requiere evidencia de asegurabilidad.",
        "key": "This_pre_existing_condition_exclusion_is_removed_if_the_insured_Employee_subsequently_applies_and_is_approved_for_additional_critical_illness_coverage_requiring_evidence_of_insurability"
    },
    {
        "English": "Pre-existing Condition Exclusion applies for the first 24 months of this coverage: Any symptom, condition, disorder, illness, pre-disease or disease, or any mental, nervous or psychiatric condition or disorder for which any one of medical advice, treatment, service, prescribed medication, diagnosis or consultation, including consultation to investigate and/or diagnose (where diagnosis has not yet been made) was received by the insured or would have been received by a prudent individual within the 24 months immediately preceding the effective date.",
        "French": "L'exclusion des affections préexistantes s'applique pendant les 24 premiers mois de cette couverture : tout symptôme, affection, trouble, maladie, pré-maladie ou affection, ou tout état ou trouble mental, nerveux ou psychiatrique pour lequel un avis médical, un traitement, service, médicament prescrit, diagnostic ou consultation, y compris une consultation pour enquêter et/ou diagnostiquer (lorsque le diagnostic n'a pas encore été posé) a été reçu par l'assuré ou aurait été reçu par une personne prudente dans les 24 mois précédant immédiatement la date d'entrée en vigueur.",
        "Spanish": "La exclusión de condiciones preexistentes se aplica durante los primeros 24 meses de esta cobertura: Cualquier síntoma, condición, trastorno, enfermedad, preenfermedad o enfermedad, o cualquier condición o trastorno mental, nervioso o psiquiátrico para el cual cualquiera de los consejos, tratamientos, servicio, medicamento recetado, diagnóstico o consulta, incluida la consulta para investigar y/o diagnosticar (cuando aún no se haya realizado el diagnóstico) fue recibido por el asegurado o habría sido recibido por una persona prudente dentro de los 24 meses inmediatamente anteriores a la fecha de vigencia.",
        "key": "Pre_existing_Condition_Exclusion_applies_for_the_first_24_months_of_this_coverage_Any_symptom_condition_disorder_illness_pre_disease_or_disease_or_any_mental_nervous_or_psychiatric_condition_or_disorder_for_which_any_one_of_medical_advice_treatment_service_prescribed_medication_diagnosis_or_consultation_including_consultation_to_investigate_and_or_diagnose_where_diagnosis_has_not_yet_been_made_was_received_by_the_insured_or_would_have_been_received_by_a_prudent_individual_within_the_24_months_immediately_preceding_the_effective_date"
    },
    {
        "English": "Please select a Provincial Health Replacement Plan.",
        "French": "Veuillez sélectionner un régime provincial de remplacement des soins de santé.",
        "Spanish": "Por favor seleccione un Plan Provincial de Reemplazo de Salud.",
        "key": "Please_select_a_Provincial_Health_Replacement_Plan"
    },
    {
        "English": "Monthly, applicable taxes extra",
        "French": "Mensuel, taxes applicables en sus",
        "Spanish": "Impuestos mensuales aplicables adicionales",
        "key": "Monthly_applicable_taxes_extra"
    },
    {
        "English": "Account Number must be 5-12 digits",
        "French": "Le numéro de compte doit comporter entre 5 et 12 chiffres",
        "Spanish": "El número de cuenta debe tener entre 5 y 12 dígitos",
        "key": "Account_Number_must_be_5_12_digits"
    },
    {
        "English": "Enter Employer Name",
        "French": "Entrez le nom de l'employeur",
        "Spanish": "Ingrese el nombre del empleador",
        "key": "Enter_Employer_Name"
    },
    {
        "English": "I confirm enrolling into voluntary opt-ins along with upgrade plans split amount and charge monthly premiums to Credit Card or PAD as per data below.",
        "French": "Je confirme mon inscription aux inscriptions volontaires ainsi qu'aux plans de mise à niveau, partageant le montant et facturant les primes mensuelles sur la carte de crédit ou le PAD selon les données ci-dessous.",
        "Spanish": "Confirmo que me inscribo en inscripciones voluntarias junto con planes de actualización que dividen el monto y cargo las primas mensuales a la tarjeta de crédito o PAD según los datos a continuación.",
        "key": "I_confirm_enrolling_into_voluntary_opt_ins_along_with_upgrade_plans_split_amount_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below"
    },
    {
        "English": "Bank Number must be 3 digits.",
        "French": "Le numéro de banque doit comporter 3 chiffres.",
        "Spanish": "El número de banco debe tener 3 dígitos.",
        "key": "Bank_Number_must_be_3_digits"
    },
    {
        "English": "I confirm enrolling into Upgrade plans split amount and charge monthly premiums to Credit Card or PAD as per data below.",
        "French": "Je confirme mon inscription aux plans de mise à niveau avec un montant partagé et je facture les primes mensuelles sur la carte de crédit ou le PAD selon les données ci-dessous.",
        "Spanish": "Confirmo que me inscribo en planes de actualización con monto dividido y cobro primas mensuales a tarjeta de crédito o PAD según los datos a continuación.",
        "key": "I_confirm_enrolling_into_Upgrade_plans_split_amount_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below"
    },
    {
        "English": "Company",
        "French": "Entreprise",
        "Spanish": "Correo del administrador",
        "key": "Company"
    },
    {
        "English": "Core Plans (Premium paid 100% by employer)",
        "French": "Plans de base (prime payée à 100 % par l'employeur)",
        "Spanish": "Planes Básicos (Prima pagada 100% por el empleador)",
        "key": "Core_Plans_Premium_paid_100_by_employer"
    },
    {
        "English": "I confirm upgrading my benefit plans and acknowledge that the difference between the plans paid by the company and my selection will deducted on my pay-check",
        "French": "Je confirme la mise à niveau de mes régimes d'avantages sociaux et reconnais que la différence entre les régimes payés par l'entreprise et ma sélection sera déduite de mon chèque de paie.",
        "Spanish": "Confirmo la actualización de mis planes de beneficios y reconozco que la diferencia entre los planes pagados por la empresa y mi selección se deducirá de mi cheque de pago.",
        "key": "I_confirm_upgrading_my_benefit_plans_and_acknowledge_that_the_difference_between_the_plans_paid_by_the_company_and_my_selection_will_deducted_on_my_pay_check"
    },
    {
        "English": "Please confirm Upgrade plans",
        "French": "Veuillez confirmer les plans de mise à niveau",
        "Spanish": "Por favor confirme los planes de actualización",
        "key": "Please_confirm_Upgrade_plans"
    },
    {
        "English": "Transit Number must be 5 digits.",
        "French": "Le numéro de transit doit comporter 5 chiffres.",
        "Spanish": "El número de tránsito debe tener 5 dígitos.",
        "key": "Transit_Number_must_be_5_digits"
    },
    {
        "English": "Please select a Health & Dental Insurance Plan along with a Life or Critical Insurance Plan.",
        "French": "Veuillez sélectionner un régime d'assurance maladie et dentaire ainsi qu'un régime d'assurance vie ou d'assurance critique.",
        "Spanish": "Seleccione un plan de seguro médico y dental junto con un plan de seguro de vida o crítico.",
        "key": "Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan"
    },
    {
        "English": "Upgrade plans",
        "French": "Plans de mise à niveau",
        "Spanish": "Planes de actualización",
        "key": "Upgrade_plans"
    },
    {
        "English": "Enter Card Number",
        "French": "Entrez le numéro de carte",
        "Spanish": "Ingrese el número de tarjeta",
        "key": "Enter_Card_Number"
    },
    {
        "English": "Select Expiry Month",
        "French": "Sélectionnez le mois d'expiration",
        "Spanish": "Seleccione el mes de vencimiento",
        "key": "Select_Expiry_Month"
    },
    {
        "English": "Select Expiry Year",
        "French": "Sélectionnez l'année d'expiration",
        "Spanish": "Seleccionar año de vencimiento",
        "key": "Select_Expiry_Year"
    },
    {
        "English": "Enter CVV",
        "French": "Entrez CVV",
        "Spanish": "Ingrese CVV",
        "key": "Enter_CVV"
    },
    {
        "English": "You pay",
        "French": "Vous payez",
        "Spanish": "tu pagas",
        "key": "You_pay"
    },
    {
        "English": "100% Company Paid",
        "French": "100 % payé par l'entreprise",
        "Spanish": "100% pagado por la empresa",
        "key": "100_Company_Paid"
    },
    {
        "English": "Please select a Health & Dental Plan along with a Insurance Plan",
        "French": "Veuillez sélectionner un régime de soins de santé et de soins dentaires ainsi qu'un régime d'assurance.",
        "Spanish": "Seleccione un plan de salud y dental junto con un plan de seguro",
        "key": "Please_select_a_Health_Dental_Plan_along_with_a_Insurance_Plan"
    },
    {
        "English": "You pay through payroll deduction",
        "French": "Vous payez par retenue sur salaire",
        "Spanish": "Pagas mediante descuento de nómina",
        "key": "You_pay_through_payroll_deduction"
    },
    {
        "English": "We are not currently operating in Quebec. Please check back with us in 2025",
        "French": "Nous n'opérons pas actuellement au Québec. Veuillez revenir avec nous en 2025",
        "Spanish": "Actualmente no estamos operando en Quebec. Vuelva a consultarnos en 2025.",
        "key": "We_are_not_currently_operating_in_Quebec_Please_check_back_with_us_in_2025"
    },
    {
        "English": "No Provincial Health Replacement plans available. Please contact your Advisor",
        "French": "Aucun régime provincial de remplacement des soins de santé n'est disponible. Veuillez contacter votre conseiller",
        "Spanish": "No hay planes Provinciales de Reemplazo de Salud disponibles. Por favor contacte a su asesor",
        "key": "No_Provincial_Health_Replacement_plans_available_Please_contact_your_Advisor"
    },
    {
        "English": "You pay through CC/PAD",
        "French": "Vous payez via CC/PAD",
        "Spanish": "Pagas a través de CC/PAD",
        "key": "You_pay_through_CC_PAD"
    },
    {
        "English": "Contingent First Name",
        "French": "Prénom du contingent",
        "Spanish": "Nombre contingente",
        "key": "Contingent_First_Name"
    },
    {
        "English": "Account No ",
        "French": "Numéro de compte ",
        "Spanish": "Número de cuenta ",
        "key": "Account_No"
    },
    {
        "English": "Account No ",
        "French": "Numéro de compte ",
        "Spanish": "Número de cuenta ",
        "key": "Account_No"
    },
    {
        "English": "Is this person under age 18",
        "French": "Cette personne a-t-elle moins de 18 ans",
        "Spanish": "¿Esta persona es menor de 18 años?",
        "key": "Is_this_person_under_age_18"
    },
    {
        "English": "Trustee Last Name",
        "French": "Nom du fiduciaire",
        "Spanish": "Apellido del Fideicomisario",
        "key": "Trustee_Last_Name"
    },
    {
        "English": "Contingent Last Name",
        "French": "Nom de famille du contingent",
        "Spanish": "Apellido contingente",
        "key": "Contingent_Last_Name"
    },
    {
        "English": "Trustee First Name",
        "French": "Prénom du fiduciaire",
        "Spanish": "Nombre del administrador",
        "key": "Trustee_First_Name"
    },
    {
        "English": "Account No ",
        "French": "Numéro de compte *",
        "Spanish": "Número de cuenta *",
        "key": "Account_No"
    },
    {
        "English": "Non Binary",
        "French": "Non binaire",
        "Spanish": "No binario",
        "key": "Non_Binary"
    },
    {
        "English": "Pre Authorized Debit",
        "French": "Débit préautorisé",
        "Spanish": "Débito preautorizado",
        "key": "Pre_Authorized_Debit"
    },
    {
        "English": "Last Name minimum of 1 Character and without numbers",
        "French": "Nom de famille minimum de 1 caractère et sans chiffres",
        "Spanish": "Apellido mínimo de 1 Carácter y sin números",
        "key": "Last_Name_minimum_of_1_Character_and_without_numbers"
    },
    {
        "English": "First Name minimum of 1 Character and without numbers",
        "French": "Prénom minimum de 1 Caractère et sans chiffres",
        "Spanish": "Nombre mínimo de 1 Carácter y sin números",
        "key": "First_Name_minimum_of_1_Character_and_without_numbers"
    },
    {
        "English": "bank number",
        "French": "numéro de banque",
        "Spanish": "número de banco",
        "key": "bank_number"
    },
    {
        "English": "This payment link has expired. Please contact the GroupBenefitz administrator(admin@groupbenefitz.ca) for further assistance.",
        "French": "Ce lien de paiement a expiré. Veuillez contacter l’administrateur GroupBenefitz (admin@groupbenefitz.ca) pour obtenir de l’aide.",
        "Spanish": "Este enlace de pago ha expirado. Por favor, póngase en contacto con el administrador de GroupBenefitz (admin@groupbenefitz.ca) para obtener ayuda.",
        "key": "This_payment_link_has_expired_Please_contact_the_GroupBenefitz_administrator_admin_groupbenefitz_ca_for_further_assistance"
    },
    {
        "English": "Do you smoke?",
        "French": "Fumez-vous ?",
        "Spanish": "¿Fuma usted?",
        "key": "Do_you_smoke"
    },
    {
        "English": "I confirm that I am actively working 30 or more hours per week to meet plan eligibility",
        "French": "Je confirme que je travaille activement 30 heures ou plus par semaine pour répondre aux critères d’éligibilité du plan",
        "Spanish": "Confirmo que trabajo activamente 30 horas o más por semana para cumplir con los requisitos de elegibilidad del plan",
        "key": "I_confirm_that_I_am_actively_working_30_or_more_hours_per_week_to_meet_plan_eligibility"
    },
    {
        "English": "Earnings amount",
        "French": "Montant des revenus",
        "Spanish": "Cantidad de ingresos",
        "key": "Earnings_amount"
    },
    {
        "English": "Earnings frequency",
        "French": "Fréquence des revenus",
        "Spanish": "Frecuencia de ingresos",
        "key": "Earnings_frequency"
    },
    {
        "English": "To enroll in the plan you need to be working 30 or more hours per week",
        "French": "Pour adhérer au plan, vous devez travailler 30 heures ou plus par semaine",
        "Spanish": "Para inscribirse en el plan, debe trabajar 30 horas o más por semana",
        "key": "To_enroll_in_the_plan_you_need_to_be_working_30_or_more_hours_per_week"
    },
    {
        "English": "Please select smoking status",
        "French": "Veuillez sélectionner le statut de fumeur",
        "Spanish": "Por favor seleccione el estado de fumador",
        "key": "Please_select_smoking_status"
    },
    {
        "English": "Please enter Occupation",
        "French": "Veuillez saisir la profession",
        "Spanish": "Por favor ingrese la ocupación",
        "key": "Please_enter_Occupation"
    },
    {
        "English": "Please enter earnings amount",
        "French": "Veuillez saisir le montant des revenus",
        "Spanish": "Por favor ingrese el monto de los ingresos",
        "key": "Please_enter_earnings_amount"
    },
    {
        "English": "Please enter place of birth",
        "French": "Veuillez saisir le lieu de naissance",
        "Spanish": "Por favor ingrese el lugar de nacimiento",
        "key": "Please_enter_place_of_birth"
    }
]
